/* ---------------------- BOOKINGS V2 - AIRPORT TRANSFER ---------------------- */

/* ----------------- ASSIGN CHAUFFEUR ----------------- */
export const ASSIGN_CHAUFFEUR = `ASSIGN_CHAUFFEUR`;
export const ASSIGN_CHAUFFEUR_SUCCESS = `ASSIGN_CHAUFFEUR_SUCCESS`;
export const ASSIGN_CHAUFFEUR_ERROR = `ASSIGN_CHAUFFEUR_ERROR`;
export const ASSIGN_CHAUFFEUR_EMPTY = `ASSIGN_CHAUFFEUR_EMPTY`;

/* ----------------- ASSIGN COACH ----------------- */
export const ASSIGN_COACH = `ASSIGN_COACH`;
export const ASSIGN_COACH_SUCCESS = `ASSIGN_COACH_SUCCESS`;
export const ASSIGN_COACH_ERROR = `ASSIGN_COACH_ERROR`;
export const ASSIGN_COACH_EMPTY = `ASSIGN_COACH_EMPTY`;

/* ----------------- BOOKING ASSIGN TO ME ----------------- */
export const BOOKING_ASSIGN_TO_ME = `BOOKING_ASSIGN_TO_ME`;
export const BOOKING_ASSIGN_TO_ME_SUCCESS = `BOOKING_ASSIGN_TO_ME_SUCCESS`;
export const BOOKING_ASSIGN_TO_ME_ERROR = `BOOKING_ASSIGN_TO_ME_ERROR`;
export const BOOKING_ASSIGN_TO_ME_EMPTY = `BOOKING_ASSIGN_TO_ME_EMPTY`;

/* ----------------- ASSIGN VENDOR ----------------- */
export const ASSIGN_VENDOR = `ASSIGN_VENDOR`;
export const ASSIGN_VENDOR_SUCCESS = `ASSIGN_VENDOR_SUCCESS`;
export const ASSIGN_VENDOR_ERROR = `ASSIGN_VENDOR_ERROR`;
export const ASSIGN_VENDOR_EMPTY = `ASSIGN_VENDOR_EMPTY`;

/* ----------------- CANCEL BOOKING BY VENDOR ----------------- */
export const CANCEL_BOOKING_BY_VENDOR = `CANCEL_BOOKING_BY_VENDOR`;
export const CANCEL_BOOKING_BY_VENDOR_SUCCESS = `CANCEL_BOOKING_BY_VENDOR_SUCCESS`;
export const CANCEL_BOOKING_BY_VENDOR_ERROR = `CANCEL_BOOKING_BY_VENDOR_ERROR`;
export const CANCEL_BOOKING_BY_VENDOR_EMPTY = `CANCEL_BOOKING_BY_VENDOR_EMPTY`;

/* ----------------- CANCELLATION REMARKS FOR VENDOR ----------------- */
export const CANCELLATION_REMARKS_FOR_VENDOR = `CANCELLATION_REMARKS_FOR_VENDOR`;
export const CANCELLATION_REMARKS_FOR_VENDOR_SUCCESS = `CANCELLATION_REMARKS_FOR_VENDOR_SUCCESS`;
export const CANCELLATION_REMARKS_FOR_VENDOR_ERROR = `CANCELLATION_REMARKS_FOR_VENDOR_ERROR`;
export const CANCELLATION_REMARKS_FOR_VENDOR_EMPTY = `CANCELLATION_REMARKS_FOR_VENDOR_EMPTY`;

/* ----------------- CONFRIM BOOKING BY VENDOR ----------------- */
export const CONFIRM_BOOKING_BY_VENDOR = `CONFIRM_BOOKING_BY_VENDOR`;
export const CONFIRM_BOOKING_BY_VENDOR_SUCCESS = `CONFIRM_BOOKING_BY_VENDOR_SUCCESS`;
export const CONFIRM_BOOKING_BY_VENDOR_ERROR = `CONFIRM_BOOKING_BY_VENDOR_ERROR`;
export const CONFIRM_BOOKING_BY_VENDOR_EMPTY = `CONFIRM_BOOKING_BY_VENDOR_EMPTY`;

/* ----------------- BULK CONFRIM BOOKING BY VENDOR ----------------- */
export const BULK_CONFIRM_BOOKING_BY_VENDOR = `BULK_CONFIRM_BOOKING_BY_VENDOR`;
export const BULK_CONFIRM_BOOKING_BY_VENDOR_SUCCESS = `BULK_CONFIRM_BOOKING_BY_VENDOR_SUCCESS`;
export const BULK_CONFIRM_BOOKING_BY_VENDOR_ERROR = `BULK_CONFIRM_BOOKING_BY_VENDOR_ERROR`;
export const BULK_CONFIRM_BOOKING_BY_VENDOR_EMPTY = `BULK_CONFIRM_BOOKING_BY_VENDOR_EMPTY`;

/* ----------------- CREATE CHAUFFEUR ----------------- */
export const CREATE_CHAUFFEUR = `CREATE_CHAUFFEUR`;
export const CREATE_CHAUFFEUR_SUCCESS = `CREATE_CHAUFFEUR_SUCCESS`;
export const CREATE_CHAUFFEUR_ERROR = `CREATE_CHAUFFEUR_ERROR`;
export const CREATE_CHAUFFEUR_EMPTY = `CREATE_CHAUFFEUR_EMPTY`;

/* ----------------- GET CARS LIST OF VENDOR ----------------- */
export const GET_CARS_LIST_OF_VENDOR = `GET_CARS_LIST_OF_VENDOR`;
export const GET_CARS_LIST_OF_VENDOR_SUCCESS = `GET_CARS_LIST_OF_VENDOR_SUCCESS`;
export const GET_CARS_LIST_OF_VENDOR_ERROR = `GET_CARS_LIST_OF_VENDOR_ERROR`;
export const GET_CARS_LIST_OF_VENDOR_EMPTY = `GET_CARS_LIST_OF_VENDOR_EMPTY`;

/* ----------------- GET CHAUFFEURS LIST ----------------- */
export const GET_CHAUFFEURS_LIST = `GET_CHAUFFEURS_LIST`;
export const GET_CHAUFFEURS_LIST_SUCCESS = `GET_CHAUFFEURS_LIST_SUCCESS`;
export const GET_CHAUFFEURS_LIST_ERROR = `GET_CHAUFFEURS_LIST_ERROR`;
export const GET_CHAUFFEURS_LIST_EMPTY = `GET_CHAUFFEURS_LIST_EMPTY`;

/* ----------------- GET COACH LIST ----------------- */
export const GET_COACH_LIST = `GET_COACH_LIST`;
export const GET_COACH_LIST_SUCCESS = `GET_COACH_LIST_SUCCESS`;
export const GET_COACH_LIST_ERROR = `GET_COACH_LIST_ERROR`;
export const GET_COACH_LIST_EMPTY = `GET_COACH_LIST_EMPTY`;

/* ----------------- GET VENDORS LIST DATA ----------------- */
export const GET_VENDORS_LIST_DATA = `GET_VENDORS_LIST_DATA`;
export const GET_VENDORS_LIST_DATA_SUCCESS = `GET_VENDORS_LIST_DATA_SUCCESS`;
export const GET_VENDORS_LIST_DATA_ERROR = `GET_VENDORS_LIST_DATA_ERROR`;
export const GET_VENDORS_LIST_DATA_EMPTY = `GET_VENDORS_LIST_DATA_EMPTY`;

/* ----------------- ASSIGN VENDOR REMARKS LIST ----------------- */
export const ASSIGN_VENDOR_REMARKS_LIST = `ASSIGN_VENDOR_REMARKS_LIST`;
export const ASSIGN_VENDOR_REMARKS_LIST_SUCCESS = `ASSIGN_VENDOR_REMARKS_LIST_SUCCESS`;
export const ASSIGN_VENDOR_REMARKS_LIST_ERROR = `ASSIGN_VENDOR_REMARKS_LIST_ERROR`;
export const ASSIGN_VENDOR_REMARKS_LIST_EMPTY = `ASSIGN_VENDOR_REMARKS_LIST_EMPTY`;

/* ----------------- GET BOOKINGS LIST ----------------- */
export const GET_BOOKINGS_LIST = `GET_BOOKINGS_LIST`;
export const GET_BOOKINGS_LIST_SUCCESS = `GET_BOOKINGS_LIST_SUCCESS`;
export const GET_BOOKINGS_LIST_ERROR = `GET_BOOKINGS_LIST_ERROR`;
export const GET_BOOKINGS_LIST_EMPTY = `GET_BOOKINGS_LIST_EMPTY`;

/* ----------------- GET BOOKING DETAILS ----------------- */
export const GET_BOOKING_DETAILS = `GET_BOOKING_DETAILS`;
export const GET_BOOKING_DETAILS_SUCCESS = `GET_BOOKING_DETAILS_SUCCESS`;
export const GET_BOOKING_DETAILS_ERROR = `GET_BOOKING_DETAILS_ERROR`;
export const GET_BOOKING_DETAILS_EMPTY = `GET_BOOKING_DETAILS_EMPTY`;

/* ----------------- GET FILTERS LIST ----------------- */
export const GET_FILTERS_LIST = `GET_FILTERS_LIST`;
export const GET_FILTERS_LIST_SUCCESS = `GET_FILTERS_LIST_SUCCESS`;
export const GET_FILTERS_LIST_ERROR = `GET_FILTERS_LIST_ERROR`;
export const GET_FILTERS_LIST_EMPTY = `GET_FILTERS_LIST_EMPTY`;

/* ----------------- NUDGE DRIVER ----------------- */
export const NUDGE_DRIVER = `NUDGE_DRIVER`;
export const NUDGE_DRIVER_SUCCESS = `NUDGE_DRIVER_SUCCESS`;
export const NUDGE_DRIVER_ERROR = `NUDGE_DRIVER_ERROR`;
export const NUDGE_DRIVER_EMPTY = `NUDGE_DRIVER_EMPTY`;

/* ----------------- GET AVAILABLE VEHICLES ----------------- */
export const GET_AVAILABLE_VEHICLES = `GET_AVAILABLE_VEHICLES`;
export const GET_AVAILABLE_VEHICLES_SUCCESS = `GET_AVAILABLE_VEHICLES_SUCCESS`;
export const GET_AVAILABLE_VEHICLES_ERROR = `GET_AVAILABLE_VEHICLES_ERROR`;
export const GET_AVAILABLE_VEHICLES_EMPTY = `GET_AVAILABLE_VEHICLES_EMPTY`;

/* ----------------- CHANGE VEHICLE ----------------- */
export const CHANGE_VEHICLE = `CHANGE_VEHICLE`;
export const CHANGE_VEHICLE_SUCCESS = `CHANGE_VEHICLE_SUCCESS`;
export const CHANGE_VEHICLE_ERROR = `CHANGE_VEHICLE_ERROR`;
export const CHANGE_VEHICLE_EMPTY = `CHANGE_VEHICLE_EMPTY`;

/* ----------------- GET FILTER VALUES ----------------- */
export const GET_FILTER_VALUES = `GET_FILTER_VALUES`;
export const GET_FILTER_VALUES_SUCCESS = `GET_FILTER_VALUES_SUCCESS`;
export const GET_FILTER_VALUES_ERROR = `GET_FILTER_VALUES_ERROR`;
export const GET_FILTER_VALUES_EMPTY = `GET_FILTER_VALUES_EMPTY`;

// GET BOOKING TYPE
export const GET_BOOKING_TYPE = `GET_BOOKING_TYPE`;
export const GET_BOOKING_TYPE_SUCCESS = `GET_BOOKING_TYPE_SUCCESS`;
export const GET_BOOKING_TYPE_ERROR = `GET_BOOKING_TYPE_ERROR`;
export const GET_BOOKING_TYPE_EMPTY = `GET_BOOKING_TYPE_EMPTY`;

// GET V2 DASHBOARD
export const GET_DASHBOARD = `GET_DASHBOARD`;
export const GET_DASHBOARD_SUCCESS = `GET_DASHBOARD_SUCCESS`;
export const GET_DASHBOARD_ERROR = `GET_DASHBOARD_ERROR`;
export const GET_DASHBOARD_EMPTY = `GET_DASHBOARD_EMPTY`;

// GET USER ROLES
export const GET_USER_ROLES = `GET_USER_ROLES`;
export const GET_USER_ROLES_SUCCESS = `GET_USER_ROLES_SUCCESS`;
export const GET_USER_ROLES_ERROR = `GET_USER_ROLES_ERROR`;
export const GET_USER_ROLES_EMPTY = `GET_USER_ROLES_EMPTY`;

// GET CARD DETAILS
export const GET_CARD_DETAILS = `GET_CARD_DETAILS`;
export const GET_CARD_DETAILS_SUCCESS = `GET_CARD_DETAILS_SUCCESS`;
export const GET_CARD_DETAILS_ERROR = `GET_CARD_DETAILS_ERROR`;
export const GET_CARD_DETAILS_EMPTY = `GET_CARD_DETAILS_EMPTY`;

/* ----------------- CANCEL BOOKING BY ADMIN ----------------- */
export const CANCEL_BOOKING_BY_ADMIN = `CANCEL_BOOKING_BY_ADMIN`;
export const CANCEL_BOOKING_BY_ADMIN_SUCCESS = `CANCEL_BOOKING_BY_ADMIN_SUCCESS`;
export const CANCEL_BOOKING_BY_ADMIN_ERROR = `CANCEL_BOOKING_BY_ADMIN_ERROR`;
export const CANCEL_BOOKING_BY_ADMIN_EMPTY = `CANCEL_BOOKING_BY_ADMIN_EMPTY`;

/* ----------------- GET BOOKING TYPE FOR GLOBAL SEARCH ----------------- */
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH`;
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_SUCCESS = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_SUCCESS`;
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_ERROR = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_ERROR`;
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_EMPTY = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_EMPTY`;

/* ----------------- GET BOOKING FOR GLOBAL SEARCH ----------------- */
export const GET_BOOKING_GLOBAL_SEARCH = `GET_BOOKING_GLOBAL_SEARCH`;
export const GET_BOOKING_GLOBAL_SEARCH_SUCCESS = `GET_BOOKING_GLOBAL_SEARCH_SUCCESS`;
export const GET_BOOKING_GLOBAL_SEARCH_ERROR = `GET_BOOKING_GLOBAL_SEARCH_ERROR`;
export const GET_BOOKING_GLOBAL_SEARCH_EMPTY = `GET_BOOKING_GLOBAL_SEARCH_EMPTY`;

/* ----------------- MODIFY FIELDS ----------------- */
export const SHOW_MODIFY_FIELDS = `SHOW_MODIFY_FIELDS`;
export const SHOW_MODIFY_FIELDS_SUCCESS = `SHOW_MODIFY_FIELDS_SUCCESS`;
export const SHOW_MODIFY_FIELDS_ERROR = `SHOW_MODIFY_FIELDS_ERROR`;
export const SHOW_MODIFY_FIELDS_EMPTY = `SHOW_MODIFY_FIELDS_EMPTY`;

/* ----------------- MODIFY BOOKING ----------------- */
export const MODIFY_BOOKING = `MODIFY_BOOKING`;
export const MODIFY_BOOKING_SUCCESS = `MODIFY_BOOKING_SUCCESS`;
export const MODIFY_BOOKING_ERROR = `MODIFY_BOOKING_ERROR`;
export const MODIFY_BOOKING_EMPTY = `MODIFY_BOOKING_EMPTY`;

/* ----------------- APPROVAL AWAITING ----------------- */
export const APPROVAL_ACTION = `APPROVAL_ACTION`;
export const APPROVAL_ACTION_SUCCESS = `APPROVAL_ACTION_SUCCESS`;
export const APPROVAL_ACTION_ERROR = `APPROVAL_ACTION_ERROR`;
export const APPROVAL_ACTION_EMPTY = `APPROVAL_ACTION_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const REMARK_STATUS = `REMARK_STATUS`;
export const REMARK_STATUS_SUCCESS = `REMARK_STATUS_SUCCESS`;
export const REMARK_STATUS_ERROR = `REMARK_STATUS_ERROR`;
export const REMARK_STATUS_EMPTY = `REMARK_STATUS_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const GET_ACTION_BY_STATUS = `GET_ACTION_BY_STATUS`;
export const GET_ACTION_BY_STATUS_SUCCESS = `GET_ACTION_BY_STATUS_SUCCESS`;
export const GET_ACTION_BY_STATUS_ERROR = `GET_ACTION_BY_STATUS_ERROR`;
export const GET_ACTION_BY_STATUS_EMPTY = `GET_ACTION_BY_STATUS_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const GET_REASON_BY_ACTIONS = `GET_REASON_BY_ACTIONS`;
export const GET_REASON_BY_ACTIONS_SUCCESS = `GET_REASON_BY_ACTIONS_SUCCESS`;
export const GET_REASON_BY_ACTIONS_ERROR = `GET_REASON_BY_ACTIONS_ERROR`;
export const GET_REASON_BY_ACTIONS_EMPTY = `GET_REASON_BY_ACTIONS_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const ADD_REASON = `ADD_REASON`;
export const ADD_REASON_SUCCESS = `ADD_REASON_SUCCESS`;
export const ADD_REASON_ERROR = `ADD_REASON_ERROR`;
export const ADD_REASON_EMPTY = `ADD_REASON_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const UPDATE_REASON = `UPDATE_REASON`;
export const UPDATE_REASON_SUCCESS = `UPDATE_REASON_SUCCESS`;
export const UPDATE_REASON_ERROR = `UPDATE_REASON_ERROR`;
export const UPDATE_REASON_EMPTY = `UPDATE_REASON_EMPTY`;

/* ----------------- COMPLETE BOOKING ----------------- */
export const COMPLETE_BOOKING = `COMPLETE_BOOKING`;
export const COMPLETE_BOOKING_SUCCESS = `COMPLETE_BOOKING_SUCCESS`;
export const COMPLETE_BOOKING_ERROR = `COMPLETE_BOOKING_ERROR`;
export const COMPLETE_BOOKING_EMPTY = `COMPLETE_BOOKING_EMPTY`;

/* ----------------- COMPLETE BOOKING ----------------- */
export const COMPLETE_BOOKING_GOLF = `COMPLETE_BOOKING_GOLF`;
export const COMPLETE_BOOKING_GOLF_SUCCESS = `COMPLETE_BOOKING_GOLF_SUCCESS`;
export const COMPLETE_BOOKING_GOLF_ERROR = `COMPLETE_BOOKING_GOLF_ERROR`;
export const COMPLETE_BOOKING_GOLF_EMPTY = `COMPLETE_BOOKING_GOLF_EMPTY`;

/* ----------------- Raise Dispute ----------------- */
export const RAISE_DISPUTE = `RAISE_DISPUTE`;
export const RAISE_DISPUTE_SUCCESS = `RAISE_DISPUTE_SUCCESS`;
export const RAISE_DISPUTE_ERROR = `RAISE_DISPUTE_ERROR`;
export const RAISE_DISPUTE_EMPTY = `RAISE_DISPUTE_EMPTY`;

/* ----------------- Booking Dump Type List ----------------- */
export const GET_BOOKING_DUMP_TYPE_LIST = `GET_BOOKING_DUMP_TYPE_LIST`;
export const GET_BOOKING_DUMP_TYPE_LIST_SUCCESS = `GET_BOOKING_DUMP_TYPE_LIST_SUCCESS`;
export const GET_BOOKING_DUMP_TYPE_LIST_ERROR = `GET_BOOKING_DUMP_TYPE_LIST_ERROR`;
export const GET_BOOKING_DUMP_TYPE_LIST_EMPTY = `GET_BOOKING_DUMP_TYPE_LIST_EMPTY`;

/* ----------------- Post Download Dump ----------------- */
export const DOWNLOAD_DUMP_ADMIN_V2 = `DOWNLOAD_DUMP_ADMIN_V2`;
export const DOWNLOAD_DUMP_ADMIN_V2_SUCCESS = `DOWNLOAD_DUMP_ADMIN_V2_SUCCESS`;
export const DOWNLOAD_DUMP_ADMIN_V2_ERROR = `DOWNLOAD_DUMP_ADMIN_V2_ERROR`;
export const DOWNLOAD_DUMP_ADMIN_V2_EMPTY = `DOWNLOAD_DUMP_ADMIN_V2_EMPTY`;

/* ----------------- Get Download Dump ----------------- */
export const GET_DOWNLOAD_DUMP_ADMIN_V2 = `GET_DOWNLOAD_DUMP_ADMIN_V2`;
export const GET_DOWNLOAD_DUMP_ADMIN_V2_SUCCESS = `GET_DOWNLOAD_DUMP_ADMIN_V2_SUCCESS`;
export const GET_DOWNLOAD_DUMP_ADMIN_V2_ERROR = `GET_DOWNLOAD_DUMP_ADMIN_V2_ERROR`;
export const GET_DOWNLOAD_DUMP_ADMIN_V2_EMPTY = `GET_DOWNLOAD_DUMP_ADMIN_V2_EMPTY`;

// ******************************* AIRPORT TRANSFER *******************************

/* ----------------- GET AIRPORTS BASED ON CONFIG ID ----------------- */
export const GET_AIRPORTS_BASED_ON_CONFIG_ID = `GET_AIRPORTS_BASED_ON_CONFIG_ID`;
export const GET_AIRPORTS_BASED_ON_CONFIG_ID_SUCCESS = `GET_AIRPORTS_BASED_ON_CONFIG_ID_SUCCESS`;
export const GET_AIRPORTS_BASED_ON_CONFIG_ID_ERROR = `GET_AIRPORTS_BASED_ON_CONFIG_ID_ERROR`;
export const GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY = `GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY`;

/* ----------------- GET RECENT SEARCHES ----------------- */
export const GET_RECENT_SEARCHES = `GET_RECENT_SEARCHES`;
export const GET_RECENT_SEARCHES_SUCCESS = `GET_RECENT_SEARCHES_SUCCESS`;
export const GET_RECENT_SEARCHES_ERROR = `GET_RECENT_SEARCHES_ERROR`;
export const GET_RECENT_SEARCHES_EMPTY = `GET_RECENT_SEARCHES_EMPTY`;

/* ----------------- GET AUTOCOMPLETE LOCATION ----------------- */
export const GET_AUTOCOMPLETE_LOCATION = `GET_AUTOCOMPLETE_LOCATION`;
export const GET_AUTOCOMPLETE_LOCATION_SUCCESS = `GET_AUTOCOMPLETE_LOCATION_SUCCESS`;
export const GET_AUTOCOMPLETE_LOCATION_ERROR = `GET_AUTOCOMPLETE_LOCATION_ERROR`;
export const GET_AUTOCOMPLETE_LOCATION_EMPTY = `GET_AUTOCOMPLETE_LOCATION_EMPTY`;

/* ----------------- VALIDATE LOCATION ----------------- */
export const VALIDATE_LOCATION = `VALIDATE_LOCATION`;
export const VALIDATE_LOCATION_SUCCESS = `VALIDATE_LOCATION_SUCCESS`;
export const VALIDATE_LOCATION_ERROR = `VALIDATE_LOCATION_ERROR`;
export const VALIDATE_LOCATION_EMPTY = `VALIDATE_LOCATION_EMPTY`;

/* ----------------- CREATE GUEST USER ----------------- */
export const CREATE_GUEST_USER = `CREATE_GUEST_USER`;
export const CREATE_GUEST_USER_SUCCESS = `CREATE_GUEST_USER_SUCCESS`;
export const CREATE_GUEST_USER_ERROR = `CREATE_GUEST_USER_ERROR`;
export const CREATE_GUEST_USER_EMPTY = `CREATE_GUEST_USER_EMPTY`;

/* ----------------- GET GUEST USERS ----------------- */
export const GET_GUEST_USERS = `GET_GUEST_USERS`;
export const GET_GUEST_USERS_SUCCESS = `GET_GUEST_USERS_SUCCESS`;
export const GET_GUEST_USERS_ERROR = `GET_GUEST_USERS_ERROR`;
export const GET_GUEST_USERS_EMPTY = `GET_GUEST_USERS_EMPTY`;

/* ----------------- UPDATE GUEST USER ----------------- */
export const UPDATE_GUEST_USER = `UPDATE_GUEST_USER`;
export const UPDATE_GUEST_USER_SUCCESS = `UPDATE_GUEST_USER_SUCCESS`;
export const UPDATE_GUEST_USER_ERROR = `UPDATE_GUEST_USER_ERROR`;
export const UPDATE_GUEST_USER_EMPTY = `UPDATE_GUEST_USER_EMPTY`;

/* ----------------- VALIDATE FLIGHT DETAILS ----------------- */
export const VALIDATE_FLIGHT_DETAILS = `VALIDATE_FLIGHT_DETAILS`;
export const VALIDATE_FLIGHT_DETAILS_SUCCESS = `VALIDATE_FLIGHT_DETAILS_SUCCESS`;
export const VALIDATE_FLIGHT_DETAILS_ERROR = `VALIDATE_FLIGHT_DETAILS_ERROR`;
export const VALIDATE_FLIGHT_DETAILS_EMPTY = `VALIDATE_FLIGHT_DETAILS_EMPTY`;

/* ----------------- GET PAYMENT SUMMARY ----------------- */
export const GET_PAYMENT_SUMMARY = `GET_PAYMENT_SUMMARY`;
export const GET_PAYMENT_SUMMARY_SUCCESS = `GET_PAYMENT_SUMMARY_SUCCESS`;
export const GET_PAYMENT_SUMMARY_ERROR = `GET_PAYMENT_SUMMARY_ERROR`;
export const GET_PAYMENT_SUMMARY_EMPTY = `GET_PAYMENT_SUMMARY_EMPTY`;

/* ----------------- CREATE AIRPORT TRANSFER BOOKING ----------------- */
export const CREATE_AIRPORT_TRANSFER_BOOKING = `CREATE_AIRPORT_TRANSFER_BOOKING`;
export const CREATE_AIRPORT_TRANSFER_BOOKING_SUCCESS = `CREATE_AIRPORT_TRANSFER_BOOKING_SUCCESS`;
export const CREATE_AIRPORT_TRANSFER_BOOKING_ERROR = `CREATE_AIRPORT_TRANSFER_BOOKING_ERROR`;
export const CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY = `CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY`;

/* ----------------- GET BOOKING SUMMARY ----------------- */
export const GET_BOOKING_SUMMARY = `GET_BOOKING_SUMMARY`;
export const GET_BOOKING_SUMMARY_SUCCESS = `GET_BOOKING_SUMMARY_SUCCESS`;
export const GET_BOOKING_SUMMARY_ERROR = `GET_BOOKING_SUMMARY_ERROR`;
export const GET_BOOKING_SUMMARY_EMPTY = `GET_BOOKING_SUMMARY_EMPTY`;

// GET NOTIFICATION BOOKING
export const GET_NOTIFICATION_BOOKING = `GET_NOTIFICATION_BOOKING`;
export const GET_NOTIFICATION_BOOKING_SUCCESS = `GET_NOTIFICATION_BOOKING_SUCCESS`;
export const GET_NOTIFICATION_BOOKING_ERROR = `GET_NOTIFICATION_BOOKING_ERROR`;
export const GET_NOTIFICATION_BOOKING_EMPTY = `GET_NOTIFICATION_BOOKING_EMPTY`;

// GET NOTIFICATION STATUS
export const GET_NOTIFICATION_STATUS = `GET_NOTIFICATION_STATUS`;
export const GET_NOTIFICATION_STATUS_SUCCESS = `GET_NOTIFICATION_STATUS_SUCCESS`;
export const GET_NOTIFICATION_STATUS_ERROR = `GET_NOTIFICATION_STATUS_ERROR`;
export const GET_NOTIFICATION_STATUS_EMPTY = `GET_NOTIFICATION_STATUS_EMPTY`;

// SEND NOTIFICATION
export const SEND_NOTIFICATION = `SEND_NOTIFICATION`;
export const SEND_NOTIFICATION_SUCCESS = `SEND_NOTIFICATION_SUCCESS`;
export const SEND_NOTIFICATION_ERROR = `SEND_NOTIFICATION_ERROR`;
export const SEND_NOTIFICATION_EMPTY = `SEND_NOTIFICATION_EMPTY`;

// REJECT SLOT OPTIONS
export const GET_REJECT_SLOT_OPTIONS = `GET_REJECT_SLOT_OPTIONS`;
export const GET_REJECT_SLOT_OPTIONS_SUCCESS = `GET_REJECT_SLOT_OPTIONS_SUCCESS`;
export const GET_REJECT_SLOT_OPTIONS_ERROR = `GET_REJECT_SLOT_OPTIONS_ERROR`;
export const GET_REJECT_SLOT_OPTIONS_EMPTY = `GET_REJECT_SLOT_OPTIONS_EMPTY`;

// REJECT SLOT OPTIONS
export const GET_REJECT_SLOT_OPTIONS_V2 = `GET_REJECT_SLOT_OPTIONS_V2`;
export const GET_REJECT_SLOT_OPTIONS_V2_SUCCESS = `GET_REJECT_SLOT_OPTIONS_V2_SUCCESS`;
export const GET_REJECT_SLOT_OPTIONS_V2_ERROR = `GET_REJECT_SLOT_OPTIONS_V2_ERROR`;
export const GET_REJECT_SLOT_OPTIONS_V2_EMPTY = `GET_REJECT_SLOT_OPTIONS_V2_EMPTY`;

// REJECT SLOT
export const REJECT_SLOT = `REJECT_SLOT`;
export const REJECT_SLOT_SUCCESS = `REJECT_SLOT_SUCCESS`;
export const REJECT_SLOT_ERROR = `REJECT_SLOT_ERROR`;
export const REJECT_SLOT_EMPTY = `REJECT_SLOT_EMPTY`;

// ADD MANUAL PRICING
export const ADD_MANUAL_PRICING = `ADD_MANUAL_PRICING`;
export const ADD_MANUAL_PRICING_SUCCESS = `ADD_MANUAL_PRICING_SUCCESS`;
export const ADD_MANUAL_PRICING_ERROR = `ADD_MANUAL_PRICING_ERROR`;
export const ADD_MANUAL_PRICING_EMPTY = `ADD_MANUAL_PRICING_EMPTY`;

// MARK NO SHOW
export const MARK_NO_SHOW = `MARK_NO_SHOW`;
export const MARK_NO_SHOW_SUCCESS = `MARK_NO_SHOW_SUCCESS`;
export const MARK_NO_SHOW_ERROR = `MARK_NO_SHOW_ERROR`;
export const MARK_NO_SHOW_EMPTY = `MARK_NO_SHOW_EMPTY`;

// VALIDATE OTP
export const VALIDATE_OTP = `VALIDATE_OTP`;
export const VALIDATE_OTP_SUCCESS = `VALIDATE_OTP_SUCCESS`;
export const VALIDATE_OTP_ERROR = `VALIDATE_OTP_ERROR`;
export const VALIDATE_OTP_EMPTY = `VALIDATE_OTP_EMPTY`;

// RESEND OTP
export const RESEND_OTP = `RESEND_OTP`;
export const RESEND_OTP_SUCCESS = `RESEND_OTP_SUCCESS`;
export const RESEND_OTP_ERROR = `RESEND_OTP_ERROR`;
export const RESEND_OTP_EMPTY = `RESEND_OTP_EMPTY`;

// SUGGEST GOLF
export const SUGGEST_GOLF = `SUGGEST_GOLF`;
export const SUGGEST_GOLF_SUCCESS = `SUGGEST_GOLF_SUCCESS`;
export const SUGGEST_GOLF_ERROR = `SUGGEST_GOLF_ERROR`;
export const SUGGEST_GOLF_EMPTY = `SUGGEST_GOLF_EMPTY`;

// SUGGEST GOLF
export const ADD_SUGGEST_GOLF = `ADD_SUGGEST_GOLF`;
export const ADD_SUGGEST_GOLF_SUCCESS = `ADD_SUGGEST_GOLF_SUCCESS`;
export const ADD_SUGGEST_GOLF_ERROR = `ADD_SUGGEST_GOLF_ERROR`;
export const ADD_SUGGEST_GOLF_EMPTY = `ADD_SUGGEST_GOLF_EMPTY`;

// GET CLIENT
export const GET_CLIENT_V2 = `GET_CLIENT_V2`;
export const GET_CLIENT_V2_SUCCESS = `GET_CLIENT_V2_SUCCESS`;
export const GET_CLIENT_V2_ERROR = `GET_CLIENT_V2_ERROR`;
export const GET_CLIENT_V2_EMPTY = `GET_CLIENT_V2_EMPTY`;

// GET CLIENT DETAILS
export const GET_CLIENT_DETAILS_V2 = `GET_CLIENT_DETAILS_V2`;
export const GET_CLIENT_DETAILS_V2_SUCCESS = `GET_CLIENT_DETAILS_V2_SUCCESS`;
export const GET_CLIENT_DETAILS_V2_ERROR = `GET_CLIENT_DETAILS_V2_ERROR`;
export const GET_CLIENT_DETAILS_V2_EMPTY = `GET_CLIENT_DETAILS_V2_EMPTY`;

// GET BENEFIT AND BENEFIT GROUP
export const GET_BENEFIT_AND_BENEFIT_GROUP = `GET_BENEFIT_AND_BENEFIT_GROUP`;
export const GET_BENEFIT_AND_BENEFIT_GROUP_SUCCESS = `GET_BENEFIT_AND_BENEFIT_GROUP_SUCCESS`;
export const GET_BENEFIT_AND_BENEFIT_GROUP_ERROR = `GET_BENEFIT_AND_BENEFIT_GROUP_ERROR`;
export const GET_BENEFIT_AND_BENEFIT_GROUP_EMPTY = `GET_BENEFIT_AND_BENEFIT_GROUP_EMPTY`;

// GET PROJECT
export const GET_PROJECT_V2 = `GET_PROJECT_V2`;
export const GET_PROJECT_V2_SUCCESS = `GET_PROJECT_V2_SUCCESS`;
export const GET_PROJECT_V2_ERROR = `GET_PROJECT_V2_ERROR`;
export const GET_PROJECT_V2_EMPTY = `GET_PROJECT_V2_EMPTY`;

// GET CORDINATE
export const GET_COORDINATES = `GET_COORDINATES`;
export const GET_COORDINATES_SUCCESS = `GET_COORDINATES_SUCCESS`;
export const GET_COORDINATES_ERROR = `GET_COORDINATES_ERROR`;
export const GET_COORDINATES_EMPTY = `GET_COORDINATES_EMPTY`;

// GET CARTYPE
export const GET_CAR_TYPE = `GET_CAR_TYPE`;
export const GET_CAR_TYPE_SUCCESS = `GET_CAR_TYPE_SUCCESS`;
export const GET_CAR_TYPE_ERROR = `GET_CAR_TYPE_ERROR`;
export const GET_CAR_TYPE_EMPTY = `GET_CAR_TYPE_EMPTY`;

// GET INVENTORY VIEW
export const GET_INVENTORY_VIEW = `GET_INVENTORY_VIEW`;
export const GET_INVENTORY_VIEW_SUCCESS = `GET_INVENTORY_VIEW_SUCCESS`;
export const GET_INVENTORY_VIEW_ERROR = `GET_INVENTORY_VIEW_ERROR`;
export const GET_INVENTORY_VIEW_EMPTY = `GET_INVENTORY_VIEW_EMPTY`;

// CREATE CLIENT
export const CREATE_CLIENT_V2 = `CREATE_CLIENT_V2`;
export const CREATE_CLIENT_V2_SUCCESS = `CREATE_CLIENT_V2_SUCCESS`;
export const CREATE_CLIENT_V2_ERROR = `CREATE_CLIENT_V2_ERROR`;
export const CREATE_CLIENT_V2_EMPTY = `CREATE_CLIENT_V2_EMPTY`;

// CREATE VENDOR
export const CREATE_VENDOR_V2 = `CREATE_VENDOR_V2`;
export const CREATE_VENDOR_V2_SUCCESS = `CREATE_VENDOR_V2_SUCCESS`;
export const CREATE_VENDOR_V2_ERROR = `CREATE_VENDOR_V2_ERROR`;
export const CREATE_VENDOR_V2_EMPTY = `CREATE_VENDOR_V2_EMPTY`;

// CHANGE VENDOR PASSWORD
export const VENDOR_CHANGE_PASSWORD = `VENDOR_CHANGE_PASSWORD`;
export const VENDOR_CHANGE_PASSWORD_SUCCESS = `VENDOR_CHANGE_PASSWORD_SUCCESS`;
export const VENDOR_CHANGE_PASSWORD_ERROR = `VENDOR_CHANGE_PASSWORD_ERROR`;
export const VENDOR_CHANGE_PASSWORD_EMPTY = `VENDOR_CHANGE_PASSWORD_EMPTY`;

// CREATE ZONES
export const CREATE_ZONES_V2 = `CREATE_ZONES_V2`;
export const CREATE_ZONES_V2_SUCCESS = `CREATE_ZONES_V2_SUCCESS`;
export const CREATE_ZONES_V2_ERROR = `CREATE_ZONES_V2_ERROR`;
export const CREATE_ZONES_V2_EMPTY = `CREATE_ZONES_V2_EMPTY`;

// CREATE AIRPORT
export const CREATE_AIRPORT_V2 = `CREATE_AIRPORT_V2`;
export const CREATE_AIRPORT_V2_SUCCESS = `CREATE_AIRPORT_V2_SUCCESS`;
export const CREATE_AIRPORT_V2_ERROR = `CREATE_AIRPORT_V2_ERROR`;
export const CREATE_AIRPORT_V2_EMPTY = `CREATE_AIRPORT_V2_EMPTY`;

// UPDATE AIRPORT
export const UPDATE_AIRPORT_V2 = `UPDATE_AIRPORT_V2`;
export const UPDATE_AIRPORT_V2_SUCCESS = `UPDATE_AIRPORT_V2_SUCCESS`;
export const UPDATE_AIRPORT_V2_ERROR = `UPDATE_AIRPORT_V2_ERROR`;
export const UPDATE_AIRPORT_V2_EMPTY = `UPDATE_AIRPORT_V2_EMPTY`;

// UPDATE CLIENT
export const UPDATE_CLIENT_V2 = `UPDATE_CLIENT_V2`;
export const UPDATE_CLIENT_V2_SUCCESS = `UPDATE_CLIENT_V2_SUCCESS`;
export const UPDATE_CLIENT_V2_ERROR = `UPDATE_CLIENT_V2_ERROR`;
export const UPDATE_CLIENT_V2_EMPTY = `UPDATE_CLIENT_V2_EMPTY`;

// UPDATE ZONES
export const UPDATE_ZONES_V2 = `UPDATE_ZONES_V2`;
export const UPDATE_ZONES_V2_SUCCESS = `UPDATE_ZONES_V2_SUCCESS`;
export const UPDATE_ZONES_V2_ERROR = `UPDATE_ZONES_V2_ERROR`;
export const UPDATE_ZONES_V2_EMPTY = `UPDATE_ZONES_V2_EMPTY`;

// UPDATE VENDOR
export const UPDATE_VENDOR_V2 = `UPDATE_VENDOR_V2`;
export const UPDATE_VENDOR_V2_SUCCESS = `UPDATE_VENDOR_V2_SUCCESS`;
export const UPDATE_VENDOR_V2_ERROR = `UPDATE_VENDOR_V2_ERROR`;
export const UPDATE_VENDOR_V2_EMPTY = `UPDATE_VENDOR_V2_EMPTY`;

// SAVE AS DRAFT
export const SAVE_DRAFT_CONFIGURATION = `SAVE_DRAFT_CONFIGURATION`;
export const SAVE_DRAFT_CONFIGURATION_SUCCESS = `SAVE_DRAFT_CONFIGURATION_SUCCESS`;
export const SAVE_DRAFT_CONFIGURATION_ERROR = `SAVE_DRAFT_CONFIGURATION_ERROR`;
export const SAVE_DRAFT_CONFIGURATION_EMPTY = `SAVE_DRAFT_CONFIGURATION_EMPTY`;

// UPDATE AS DRAFT
export const UPDATE_DRAFT_CONFIGURATION = `UPDATE_DRAFT_CONFIGURATION`;
export const UPDATE_DRAFT_CONFIGURATION_SUCCESS = `UPDATE_DRAFT_CONFIGURATION_SUCCESS`;
export const UPDATE_DRAFT_CONFIGURATION_ERROR = `UPDATE_DRAFT_CONFIGURATION_ERROR`;
export const UPDATE_DRAFT_CONFIGURATION_EMPTY = `UPDATE_DRAFT_CONFIGURATION_EMPTY`;

// DOWNLOAD PRICE FILE
export const DOWNLOAD_PRICE_FILE = `DOWNLOAD_PRICE_FILE`;
export const DOWNLOAD_PRICE_FILE_SUCCESS = `DOWNLOAD_PRICE_FILE_SUCCESS`;
export const DOWNLOAD_PRICE_FILE_ERROR = `DOWNLOAD_PRICE_FILE_ERROR`;
export const DOWNLOAD_PRICE_FILE_EMPTY = `DOWNLOAD_PRICE_FILE_EMPTY`;

// DOWNLOAD PRICE FILE
export const UPLOAD_PRICE_FILE = `UPLOAD_PRICE_FILE`;
export const UPLOAD_PRICE_FILE_SUCCESS = `UPLOAD_PRICE_FILE_SUCCESS`;
export const UPLOAD_PRICE_FILE_ERROR = `UPLOAD_PRICE_FILE_ERROR`;
export const UPLOAD_PRICE_FILE_EMPTY = `UPLOAD_PRICE_FILE_EMPTY`;

// GET ONBOARDING
export const GET_ONBOARDING_CONFIGURATION = `GET_ONBOARDING_CONFIGURATION`;
export const GET_ONBOARDING_CONFIGURATION_SUCCESS = `GET_ONBOARDING_CONFIGURATION_SUCCESS`;
export const GET_ONBOARDING_CONFIGURATION_ERROR = `GET_ONBOARDING_CONFIGURATION_ERROR`;
export const GET_ONBOARDING_CONFIGURATION_EMPTY = `GET_ONBOARDING_CONFIGURATION_EMPTY`;

// DOWNLOAD PRICE FILE
export const APPROVAL_ACTION_CONFIGURATION = `APPROVAL_ACTION_CONFIGURATION`;
export const APPROVAL_ACTION_CONFIGURATION_SUCCESS = `APPROVAL_ACTION_CONFIGURATION_SUCCESS`;
export const APPROVAL_ACTION_CONFIGURATION_ERROR = `APPROVAL_ACTION_CONFIGURATION_ERROR`;
export const APPROVAL_ACTION_CONFIGURATION_EMPTY = `APPROVAL_ACTIONFor_EMPTY`;

// GET LIVE CONFIG
export const GET_LIVE_CONFIG = `GET_LIVE_CONFIG`;
export const GET_LIVE_CONFIG_SUCCESS = `GET_LIVE_CONFIG_SUCCESS`;
export const GET_LIVE_CONFIG_ERROR = `GET_LIVE_CONFIG_ERROR`;
export const GET_LIVE_CONFIG_EMPTY = `GET_LIVE_CONFIG_EMPTY`;

// PUBLISH CONFIGURATION
export const PUBLISH_CONFIGURATION = `PUBLISH_CONFIGURATION`;
export const PUBLISH_CONFIGURATION_SUCCESS = `PUBLISH_CONFIGURATION_SUCCESS`;
export const PUBLISH_CONFIGURATION_ERROR = `PUBLISH_CONFIGURATION_ERROR`;
export const PUBLISH_CONFIGURATION_EMPTY = `PUBLISH_CONFIGURATION_EMPTY`;

// PUBLISH CONFIGURATION
export const PUBLISH_APPROVAL = `PUBLISH_APPROVAL`;
export const PUBLISH_APPROVAL_SUCCESS = `PUBLISH_APPROVAL_SUCCESS`;
export const PUBLISH_APPROVAL_ERROR = `PUBLISH_APPROVAL_ERROR`;
export const PUBLISH_APPROVAL_EMPTY = `PUBLISH_APPROVAL_EMPTY`;

// DOWNLOAD PRICE FILE
export const VALIDATE_ZONE = `VALIDATE_ZONE`;
export const VALIDATE_ZONE_SUCCESS = `VALIDATE_ZONE_SUCCESS`;
export const VALIDATE_ZONE_ERROR = `VALIDATE_ZONE_ERROR`;
export const VALIDATE_ZONE_EMPTY = `VALIDATE_ZONE_EMPTY`;

// DOWNLOAD PRICE FILE
export const GET_POLYGON_REGION = `GET_POLYGON_REGION`;
export const GET_POLYGON_REGION_SUCCESS = `GET_POLYGON_REGION_SUCCESS`;
export const GET_POLYGON_REGION_ERROR = `GET_POLYGON_REGION_ERROR`;
export const GET_POLYGON_REGION_EMPTY = `GET_POLYGON_REGION_EMPTY`;

// PUBLISH CONFIGURATION
export const REVOKE_CONFIGURATION = `REVOKE_CONFIGURATION`;
export const REVOKE_CONFIGURATION_SUCCESS = `REVOKE_CONFIGURATION_SUCCESS`;
export const REVOKE_CONFIGURATION_ERROR = `REVOKE_CONFIGURATION_ERROR`;
export const REVOKE_CONFIGURATION_EMPTY = `REVOKE_CONFIGURATION_EMPTY`;

// GET VENDOR
export const GET_VENDOR_LIST = `GET_VENDOR_LIST`;
export const GET_VENDOR_LIST_SUCCESS = `GET_VENDOR_LIST_SUCCESS`;
export const GET_VENDOR_LIST_ERROR = `GET_VENDOR_LIST_ERROR`;
export const GET_VENDOR_LIST_EMPTY = `GET_VENDOR_LIST_EMPTY`;

// GET PROJECT LIST
export const GET_PROJECT_LIST = `GET_PROJECT_LIST`;
export const GET_PROJECT_LIST_SUCCESS = `GET_PROJECT_LIST_SUCCESS`;
export const GET_PROJECT_LIST_ERROR = `GET_PROJECT_LIST_ERROR`;
export const GET_PROJECT_LIST_EMPTY = `GET_PROJECT_LIST_EMPTY`;

// UPLOAD CANCELATION FILE
export const UPLOAD_CANCELATION_FILE = `UPLOAD_CANCELATION_FILE`;
export const UPLOAD_CANCELATION_FILE_SUCCESS = `UPLOAD_CANCELATION_FILE_SUCCESS`;
export const UPLOAD_CANCELATION_FILE_ERROR = `UPLOAD_CANCELATION_FILE_ERROR`;
export const UPLOAD_CANCELATION_FILE_EMPTY = `UPLOAD_CANCELATION_FILE_EMPTY`;

// UPLOAD CANCELATION FILE
export const CANCELLED_WITH_VENDOR = `CANCELLED_WITH_VENDOR`;
export const CANCELLED_WITH_VENDOR_SUCCESS = `CANCELLED_WITH_VENDOR_SUCCESS`;
export const CANCELLED_WITH_VENDOR_ERROR = `CANCELLED_WITH_VENDOR_ERROR`;
export const CANCELLED_WITH_VENDOR_EMPTY = `CANCELLED_WITH_VENDOR_EMPTY`;

// VIEW PRICE
export const VIEW_PRICING = `VIEW_PRICING`;
export const VIEW_PRICING_SUCCESS = `VIEW_PRICING_SUCCESS`;
export const VIEW_PRICING_ERROR = `VIEW_PRICING_ERROR`;
export const VIEW_PRICING_EMPTY = `VIEW_PRICING_EMPTY`;

// DOWNLOAD PRICE
export const DOWNLOAD_PRICING = `DOWNLOAD_PRICING`;
export const DOWNLOAD_PRICING_SUCCESS = `DOWNLOAD_PRICING_SUCCESS`;
export const DOWNLOAD_PRICING_ERROR = `DOWNLOAD_PRICING_ERROR`;
export const DOWNLOAD_PRICING_EMPTY = `DOWNLOAD_PRICING_EMPTY`;

// VALIDATE RESET
export const Vendor_UNASSIGNED = `Vendor_UNASSIGNED`;
export const Vendor_UNASSIGNED_SUCCESS = `Vendor_UNASSIGNED_SUCCESS`;
export const Vendor_UNASSIGNED_ERROR = `Vendor_UNASSIGNED_ERROR`;
export const Vendor_UNASSIGNED_EMPTY = `Vendor_UNASSIGNED_EMPTY`;

// GET LIVE Benefit Group
export const GET_LIVE_BENEFIT_GROUP = `GET_LIVE_BENEFIT_GROUP`;
export const GET_LIVE_BENEFIT_GROUP_SUCCESS = `GET_LIVE_BENEFIT_GROUP_SUCCESS`;
export const GET_LIVE_BENEFIT_GROUP_ERROR = `GET_LIVE_BENEFIT_GROUP_ERROR`;
export const GET_LIVE_BENEFIT_GROUP_EMPTY = `GET_LIVE_BENEFIT_GROUP_EMPTY`;

/* ---------------------- Customer 360 ---------------------- */

// CUSTOMER 360
export const CUSTOMER_VERIFICATION = `CUSTOMER_VERIFICATION`;
export const CUSTOMER_VERIFICATION_SUCCESS = `CUSTOMER_VERIFICATION_SUCCESS`;
export const CUSTOMER_VERIFICATION_ERROR = `CUSTOMER_VERIFICATION_ERROR`;
export const CUSTOMER_VERIFICATION_EMPTY = `CUSTOMER_VERIFICATION_EMPTY`;

// CUSTOMER SESSION
export const CUSTOMER_SESSION = `CUSTOMER_SESSION`;
export const CUSTOMER_SESSION_SUCCESS = `CUSTOMER_SESSION_SUCCESS`;
export const CUSTOMER_SESSION_ERROR = `CUSTOMER_SESSION_ERROR`;
export const CUSTOMER_SESSION_EMPTY = `CUSTOMER_SESSION_EMPTY`;

//CUSTOMER USER DETAIL
export const CUSTOMER_USER_DETAIL = `CUSTOMER_USER_DETAIL`;
export const CUSTOMER_USER_DETAIL_SUCCESS = `CUSTOMER_USER_DETAIL_SUCCESS`;
export const CUSTOMER_USER_DETAIL_ERROR = `CUSTOMER_USER_DETAIL_ERROR`;
export const CUSTOMER_USER_DETAIL_EMPTY = `CUSTOMER_USER_DETAIL_EMPTY`;

//CUSTOMER DETAIL VERIFY
export const CUSTOMER_DETAIL_VERIFY = `CUSTOMER_DETAIL_VERIFY`;
export const CUSTOMER_DETAIL_VERIFY_SUCCESS = `CUSTOMER_DETAIL_VERIFY_SUCCESS`;
export const CUSTOMER_DETAIL_VERIFY_ERROR = `CUSTOMER_DETAIL_VERIFY_ERROR`;
export const CUSTOMER_DETAIL_VERIFY_EMPTY = `CUSTOMER_DETAIL_VERIFY_EMPTY`;

//ACTIVECALLERSESSION
export const ACTIVE_CALLER_SESSION = `ACTIVE_CALLER_SESSION`;
export const ACTIVE_CALLER_SESSION_SUCCESS = `ACTIVE_CALLER_SESSION_SUCCESS`;
export const ACTIVE_CALLER_SESSION_ERROR = `ACTIVE_CALLER_SESSION_ERROR`;
export const ACTIVE_CALLER_SESSION_EMPTY = `ACTIVE_CALLER_SESSION_EMPTY`;

//PROFILETABDASHBOARD
export const PROFILE_TAB_DASHBOARD = `PROFILE_TAB_DASHBOARD`;
export const PROFILE_TAB_DASHBOARD_SUCCESS = `PROFILE_TAB_DASHBOARD_SUCCESS`;
export const PROFILE_TAB_DASHBOARD_ERROR = `PROFILE_TAB_DASHBOARD_ERROR`;
export const PROFILE_TAB_DASHBOARD_EMPTY = `PROFILE_TAB_DASHBOARD_EMPTY`;

//PERSONAL DETAIL
export const PERSONAL_DETAIL = `PERSONAL_DETAIL`;
export const PERSONAL_DETAIL_SUCCESS = `PERSONAL_DETAIL_SUCCESS`;
export const PERSONAL_DETAIL_ERROR = `PERSONAL_DETAIL_ERROR`;
export const PERSONAL_DETAIL_EMPTY = `PERSONAL_DETAIL_EMPTY`;

//CUSTOMER ISSUES
export const GET_CUSTOMER_ISSUES = `GET_CUSTOMER_ISSUES`;
export const GET_CUSTOMER_ISSUES_SUCCESS = `GET_CUSTOMER_ISSUES_SUCCESS`;
export const GET_CUSTOMER_ISSUES_ERROR = `GET_CUSTOMER_ISSUES_ERROR`;
export const GET_CUSTOMER_ISSUES_EMPTY = `GET_CUSTOMER_ISSUES_EMPTY`;

//CUSTOMER RESOLUTIONS
export const GET_CUSTOMER_RESOLUTIONS = `GET_CUSTOMER_RESOLUTIONS`;
export const GET_CUSTOMER_RESOLUTIONS_SUCCESS = `GET_CUSTOMER_RESOLUTIONS_SUCCESS`;
export const GET_CUSTOMER_RESOLUTIONS_ERROR = `GET_CUSTOMER_RESOLUTIONS_ERROR`;
export const GET_CUSTOMER_RESOLUTIONS_EMPTY = `GET_CUSTOMER_RESOLUTIONS_EMPTY`;

//ISSUE LOG
export const GET_ISSUE_LOG = `GET_ISSUE_LOG`;
export const GET_ISSUE_LOG_SUCCESS = `GET_ISSUE_LOG_SUCCESS`;
export const GET_ISSUE_LOG_ERROR = `GET_ISSUE_LOG_ERROR`;
export const GET_ISSUE_LOG_EMPTY = `GET_ISSUE_LOG_EMPTY`;

//EXECUTE RESOLUTION
export const GET_BOOKING_LIFECYCLE_TIMELINE = `GET_BOOKING_LIFECYCLE_TIMELINE`;
export const GET_BOOKING_LIFECYCLE_TIMELINE_SUCCESS = `GET_BOOKING_LIFECYCLE_TIMELINE_SUCCESS`;
export const GET_BOOKING_LIFECYCLE_TIMELINE_ERROR = `GET_BOOKING_LIFECYCLE_TIMELINE_ERROR`;
export const GET_BOOKING_LIFECYCLE_TIMELINE_EMPTY = `GET_BOOKING_LIFECYCLE_TIMELINE_EMPTY`;

export const MARK_CLOSE_TICKET = `MARK_CLOSE_TICKET`;
export const MARK_CLOSE_TICKET_SUCCESS = `MARK_CLOSE_TICKET_SUCCESS`;
export const MARK_CLOSE_TICKET_ERROR = `MARK_CLOSE_TICKET_ERROR`;
export const MARK_CLOSE_TICKET_EMPTY = `MARK_CLOSE_TICKET_EMPTY`;

//SUGGESTED CATEGORY
export const GET_SUGGESTED_CATEGORY = `GET_SUGGESTED_CATEGORY`;
export const GET_SUGGESTED_CATEGORY_SUCCESS = `GET_SUGGESTED_CATEGORY_SUCCESS`;
export const GET_SUGGESTED_CATEGORY_ERROR = `GET_SUGGESTED_CATEGORY_ERROR`;
export const GET_SUGGESTED_CATEGORY_EMPTY = `GET_SUGGESTED_CATEGORY_EMPTY`;

//BOOKING DROPDOWN
export const GET_BOOKING_DROPDOWN = `GET_BOOKING_DROPDOWN`;
export const GET_BOOKING_DROPDOWN_SUCCESS = `GET_BOOKING_DROPDOWN_SUCCESS`;
export const GET_BOOKING_DROPDOWN_ERROR = `GET_BOOKING_DROPDOWN_ERROR`;
export const GET_BOOKING_DROPDOWN_EMPTY = `GET_BOOKING_DROPDOWN_EMPTY`;

//PARK TICKET
export const PARK_TICKET = `PARK_TICKET`;
export const PARK_TICKET_SUCCESS = `PARK_TICKET_SUCCESS`;
export const PARK_TICKET_ERROR = `PARK_TICKET_ERROR`;
export const PARK_TICKET_EMPTY = `PARK_TICKET_EMPTY`;

export const CALLBACK_REQUEST = `CALLBACK_REQUEST`;
export const CALLBACK_REQUEST_SUCCESS = `CALLBACK_REQUEST_SUCCESS`;
export const CALLBACK_REQUEST_ERROR = `CALLBACK_REQUEST_ERROR`;
export const CALLBACK_REQUEST_EMPTY = `CALLBACK_REQUEST_EMPTY`;

export const EXECUTE_RESOLUTION = `EXECUTE_RESOLUTION`;
export const EXECUTE_RESOLUTION_SUCCESS = `EXECUTE_RESOLUTION_SUCCESS`;
export const EXECUTE_RESOLUTION_ERROR = `EXECUTE_RESOLUTION_ERROR`;
export const EXECUTE_RESOLUTION_EMPTY = `EXECUTE_RESOLUTION_EMPTY`;

//ADMIN BOOKING DETAILS (booking modification resolution)
export const GET_ADMIN_BOOKING_DETAILS = `GET_ADMIN_BOOKING_DETAILS`;
export const GET_ADMIN_BOOKING_DETAILS_SUCCESS = `GET_ADMIN_BOOKING_DETAILS_SUCCESS`;
export const GET_ADMIN_BOOKING_DETAILS_ERROR = `GET_ADMIN_BOOKING_DETAILS_ERROR`;
export const GET_ADMIN_BOOKING_DETAILS_EMPTY = `GET_ADMIN_BOOKING_DETAILS_EMPTY`;

//BOOKING MODIFICATION FACILITIES
export const GET_BOOKING_MODIFICATION_FACILITIES = `GET_BOOKING_MODIFICATION_FACILITIES`;
export const GET_BOOKING_MODIFICATION_FACILITIES_SUCCESS = `GET_BOOKING_MODIFICATION_FACILITIES_SUCCESS`;
export const GET_BOOKING_MODIFICATION_FACILITIES_ERROR = `GET_BOOKING_MODIFICATION_FACILITIES_ERROR`;
export const GET_BOOKING_MODIFICATION_FACILITIES_EMPTY = `GET_BOOKING_MODIFICATION_FACILITIES_EMPTY`;

//DASHBOARD DEVICES
export const DASHBOARD_DEVICES = `DASHBOARD_DEVICES`;
export const DASHBOARD_DEVICES_SUCCESS = `DASHBOARD_DEVICES_SUCCESS`;
export const DASHBOARD_DEVICES_ERROR = `DASHBOARD_DEVICES_ERROR`;
export const DASHBOARD_DEVICES_EMPTY = `DASHBOARD_DEVICES_EMPTY`;

// REACTIVE USER
export const REACTIVE_USER = `REACTIVE_USER`;
export const REACTIVE_USER_SUCCESS = `REACTIVE_USER_SUCCESS`;
export const REACTIVE_USER_ERROR = `REACTIVE_USER_ERROR`;
export const REACTIVE_USER_EMPTY = `REACTIVE_USER_EMPTY`;

// GET MEMBERSHIP BY USER
export const GET_MEMBERSHIP_BY_USER = `GET_MEMBERSHIP_BY_USER`;
export const GET_MEMBERSHIP_BY_USER_SUCCESS = `GET_MEMBERSHIP_BY_USER_SUCCESS`;
export const GET_MEMBERSHIP_BY_USER_ERROR = `GET_MEMBERSHIP_BY_USER_ERROR`;
export const GET_MEMBERSHIP_BY_USER_EMPTY = `GET_MEMBERSHIP_BY_USER_EMPTY`;

// GET CARD BY USER
export const GET_CARD_BY_USER = `GET_CARD_BY_USER`;
export const GET_CARD_BY_USER_SUCCESS = `GET_CARD_BY_USER_SUCCESS`;
export const GET_CARD_BY_USER_ERROR = `GET_CARD_BY_USER_ERROR`;
export const GET_CARD_BY_USER_EMPTY = `GET_CARD_BY_USER_EMPTY`;

// GET SSO TOKEN
export const GET_SSO_TOKEN = `GET_SSO_TOKEN`;
export const GET_SSO_TOKEN_SUCCESS = `GET_SSO_TOKEN_SUCCESS`;
export const GET_SSO_TOKEN_ERROR = `GET_SSO_TOKEN_ERROR`;
export const GET_SSO_TOKEN_EMPTY = `GET_SSO_TOKEN_EMPTY`;

// SUPPORT TICKET
export const SUPPORT_TICKET = `SUPPORT_TICKET`;
export const SUPPORT_TICKET_SUCCESS = `SUPPORT_TICKET_SUCCESS`;
export const SUPPORT_TICKET_ERROR = `SUPPORT_TICKET_ERROR`;
export const SUPPORT_TICKET_EMPTY = `SUPPORT_TICKET_EMPTY`;

//RECENT ACTIVITY PROFILE
export const RECENT_ACTIVITY_PROFILE = `RECENT_ACTIVITY_PROFILE`;
export const RECENT_ACTIVITY_PROFILE_SUCCESS = `RECENT_ACTIVITY_PROFILE_SUCCESS`;
export const RECENT_ACTIVITY_PROFILE_ERROR = `RECENT_ACTIVITY_PROFILE_ERROR`;
export const RECENT_ACTIVITY_PROFILE_EMPTY = `RECENT_ACTIVITY_PROFILE_EMPTY`;

//RECENTACTIVITYMEMBERSHIP
export const RECENT_ACTIVITY_MEMBERSHIP = `RECENT_ACTIVITY_MEMBERSHIP`;
export const RECENT_ACTIVITY_MEMBERSHIP_SUCCESS = `RECENT_ACTIVITY_MEMBERSHIP_SUCCESS`;
export const RECENT_ACTIVITY_MEMBERSHIP_ERROR = `RECENT_ACTIVITY_MEMBERSHIP_ERROR`;
export const RECENT_ACTIVITY_MEMBERSHIP_EMPTY = `RECENT_ACTIVITY_MEMBERSHIP_EMPTY`;

// GET BOOKING LOGS
export const GET_BOOKING_LOGS = `GET_BOOKING_LOGS`;
export const GET_BOOKING_LOGS_SUCCESS = `GET_BOOKING_LOGS_SUCCESS`;
export const GET_BOOKING_LOGS_ERROR = `GET_BOOKING_LOGS_ERROR`;
export const GET_BOOKING_LOGS_EMPTY = `GET_BOOKING_LOGS_EMPTY`;

//SHOWHIDEMEMBERSHIPCARD
export const SHOW_HIDE_MEMBERSHIP_CARD = `SHOW_HIDE_MEMBERSHIP_CARD`;
export const SHOW_HIDE_MEMBERSHIP_CARD_SUCCESS = `SHOW_HIDE_MEMBERSHIP_CARD_SUCCESS`;
export const SHOW_HIDE_MEMBERSHIP_CARD_ERROR = `SHOW_HIDE_MEMBERSHIP_CARD_ERROR`;
export const SHOW_HIDE_MEMBERSHIP_CARD_EMPTY = `SHOW_HIDE_MEMBERSHIP_CARD_EMPTY`;

// LOGOUT CUSTOMER 360
export const LOGOUT_CUSTOMER_360 = `LOGOUT_CUSTOMER_360`;
export const LOGOUT_CUSTOMER_360_SUCCESS = `LOGOUT_CUSTOMER_360_SUCCESS`;
export const LOGOUT_CUSTOMER_360_ERROR = `LOGOUT_CUSTOMER_360_ERROR`;
export const LOGOUT_CUSTOMER_360_EMPTY = `LOGOUT_CUSTOMER_360_EMPTY`;

// LOGOUT CUSTOMER 360
export const CHANGE_MEMBERSHIP = `CHANGE_MEMBERSHIP`;
export const CHANGE_MEMBERSHIP_SUCCESS = `CHANGE_MEMBERSHIP_SUCCESS`;
export const CHANGE_MEMBERSHIP_ERROR = `CHANGE_MEMBERSHIP_ERROR`;
export const CHANGE_MEMBERSHIP_EMPTY = `CHANGE_MEMBERSHIP_EMPTY`;

// LOGOUT CUSTOMER 360
export const GET_FILTER_360 = `GET_FILTER_360`;
export const GET_FILTER_360_SUCCESS = `GET_FILTER_360_SUCCESS`;
export const GET_FILTER_360_ERROR = `GET_FILTER_360_ERROR`;
export const GET_FILTER_360_EMPTY = `GET_FILTER_360_EMPTY`;
//SENDVERIFICATIONLINK
export const SEND_VERIFICATION_LINK = `SEND_VERIFICATION_LINK`;
export const SEND_VERIFICATION_LINK_SUCCESS = `SEND_VERIFICATION_LINK_SUCCESS`;
export const SEND_VERIFICATION_LINK_ERROR = `SEND_VERIFICATION_LINK_ERROR`;
export const SEND_VERIFICATION_LINK_EMPTY = `SEND_VERIFICATION_LINK_EMPTY`;

//RESENDVERIFICATIONLINK
export const RESEND_VERIFICATION_LINK = `RESEND_VERIFICATION_LINK`;
export const RESEND_VERIFICATION_LINK_SUCCESS = `RESEND_VERIFICATION_LINK_SUCCESS`;
export const RESEND_VERIFICATION_LINK_ERROR = `RESEND_VERIFICATION_LINK_ERROR`;
export const RESEND_VERIFICATION_LINK_EMPTY = `RESEND_VERIFICATION_LINK_EMPTY`;

// GET QUOTA
export const GET_QUOTA = `GET_QUOTA`;
export const GET_QUOTA_SUCCESS = `GET_QUOTA_SUCCESS`;
export const GET_QUOTA_ERROR = `GET_QUOTA_ERROR`;
export const GET_QUOTA_EMPTY = `GET_QUOTA_EMPTY`;

// GET PAYMENT SUMMARY
export const GET_PAYMENT_SUMMARY_360 = `GET_PAYMENT_SUMMARY_360`;
export const GET_PAYMENT_SUMMARY_360_SUCCESS = `GET_PAYMENT_SUMMARY_360_SUCCESS`;
export const GET_PAYMENT_SUMMARY_360_ERROR = `GET_PAYMENT_SUMMARY_360_ERROR`;
export const GET_PAYMENT_SUMMARY_360_EMPTY = `GET_PAYMENT_SUMMARY_360_EMPTY`;

// GET SSO TOKEN
export const GET_SUPPORT_SUMMARY = `GET_SUPPORT_SUMMARY`;
export const GET_SUPPORT_SUMMARY_SUCCESS = `GET_SUPPORT_SUMMARY_SUCCESS`;
export const GET_SUPPORT_SUMMARY_ERROR = `GET_SUPPORT_SUMMARY_ERROR`;
export const GET_SUPPORT_SUMMARY_EMPTY = `GET_SUPPORT_SUMMARY_EMPTY`;

//EVENTTRACK
export const EVENT_TRACK = `EVENT_TRACK`;
export const EVENT_TRACK_SUCCESS = `EVENT_TRACK_SUCCESS`;
export const EVENT_TRACK_ERROR = `EVENT_TRACK_ERROR`;
export const EVENT_TRACK_EMPTY = `EVENT_TRACK_EMPTY`;

// CUSTOMER APPROVAL
export const CUSTOMER_APPROVAL = `CUSTOMER_APPROVAL`;
export const CUSTOMER_APPROVAL_SUCCESS = `CUSTOMER_APPROVAL_SUCCESS`;
export const CUSTOMER_APPROVAL_ERROR = `CUSTOMER_APPROVAL_ERROR`;
export const CUSTOMER_APPROVAL_EMPTY = `CUSTOMER_APPROVAL_EMPTY`;

// VOUCHER APPROVAL
export const VOUCHER_APPROVAL = `VOUCHER_APPROVAL`;
export const VOUCHER_APPROVAL_SUCCESS = `VOUCHER_APPROVAL_SUCCESS`;
export const VOUCHER_APPROVAL_ERROR = `VOUCHER_APPROVAL_ERROR`;
export const VOUCHER_APPROVAL_EMPTY = `VOUCHER_APPROVAL_EMPTY`;

// VOUCHER APPROVAL
export const MANUAL_REGISTRATION_APPROVAL = `MANUAL_REGISTRATION_APPROVAL`;
export const MANUAL_REGISTRATION_APPROVAL_SUCCESS = `MANUAL_REGISTRATION_APPROVAL_SUCCESS`;
export const MANUAL_REGISTRATION_APPROVAL_ERROR = `MANUAL_REGISTRATION_APPROVAL_ERROR`;
export const MANUAL_REGISTRATION_APPROVAL_EMPTY = `MANUAL_REGISTRATION_APPROVAL_EMPTY`;

// VOUCHER APPROVAL
export const APPROVAL_PROFILE_360 = `APPROVAL_PROFILE_360`;
export const APPROVAL_PROFILE_360_SUCCESS = `APPROVAL_PROFILE_360_SUCCESS`;
export const APPROVAL_PROFILE_360_ERROR = `APPROVAL_PROFILE_360_ERROR`;
export const APPROVAL_PROFILE_360_EMPTY = `APPROVAL_PROFILE_360_EMPTY`;

//SUPPORT TICKET FILTER
export const GET_SUPPORT_FILTER = `GET_SUPPORT_FILTER`;
export const GET_SUPPORT_FILTER_SUCCESS = `GET_SUPPORT_FILTER_SUCCESS`;
export const GET_SUPPORT_FILTER_ERROR = `GET_SUPPORT_FILTER_ERROR`;
export const GET_SUPPORT_FILTER_EMPTY = `GET_SUPPORT_FILTER_EMPTY`;

//SUPPORT TICKET FILTER
export const SUPPORT_FILTER = `SUPPORT_FILTER`;
export const SUPPORT_FILTER_SUCCESS = `SUPPORT_FILTER_SUCCESS`;
export const SUPPORT_FILTER_ERROR = `SUPPORT_FILTER_ERROR`;
export const SUPPORT_FILTER_EMPTY = `SUPPORT_FILTER_EMPTY`;

// CREATE CHAUFFEUR
export const CREATE_CHAUFFEUR_V2 = `CREATE_CHAUFFEUR_V2`;
export const CREATE_CHAUFFEUR_V2_SUCCESS = `CREATE_CHAUFFEUR_V2_SUCCESS`;
export const CREATE_CHAUFFEUR_V2_ERROR = `CREATE_CHAUFFEUR_V2_ERROR`;
export const CREATE_CHAUFFEUR_V2_EMPTY = `CREATE_CHAUFFEUR_V2_EMPTY`;

// UPDATE CHAUFFEUR
export const UPDATE_CHAUFFEUR = `UPDATE_CHAUFFEUR`;
export const UPDATE_CHAUFFEUR_SUCCESS = `UPDATE_CHAUFFEUR_SUCCESS`;
export const UPDATE_CHAUFFEUR_ERROR = `UPDATE_CHAUFFEUR_ERROR`;
export const UPDATE_CHAUFFEUR_EMPTY = `UPDATE_CHAUFFEUR_EMPTY`;

//GET SOURCE LIST
export const GET_SOURCE_LIST = `GET_SOURCE_LIST`;
export const GET_SOURCE_LIST_SUCCESS = `GET_SOURCE_LIST_SUCCESS`;
export const GET_SOURCE_LIST_ERROR = `GET_SOURCE_LIST_ERROR`;
export const GET_SOURCE_LIST_EMPTY = `GET_SOURCE_LIST_EMPTY`;

//GET ISSUE TYPES
export const GET_ISSUE_TYPES = `GET_ISSUE_TYPES`;
export const GET_ISSUE_TYPES_SUCCESS = `GET_ISSUE_TYPES_SUCCESS`;
export const GET_ISSUE_TYPES_ERROR = `GET_ISSUE_TYPES_ERROR`;
export const GET_ISSUE_TYPES_EMPTY = `GET_ISSUE_TYPES_EMPTY`;

//GET CATEGORY TICKET
export const GET_CATEGORY_TICKET = `GET_CATEGORY_TICKET`;
export const GET_CATEGORY_TICKET_SUCCESS = `GET_CATEGORY_TICKET_SUCCESS`;
export const GET_CATEGORY_TICKET_ERROR = `GET_CATEGORY_TICKET_ERROR`;
export const GET_CATEGORY_TICKET_EMPTY = `GET_CATEGORY_TICKET_EMPTY`;

//GET SUB CATEGORY TICKET
export const GET_SUB_CATEGORY_TICKET = `GET_SUB_CATEGORY_TICKET`;
export const GET_SUB_CATEGORY_TICKET_SUCCESS = `GET_SUB_CATEGORY_TICKET_SUCCESS`;
export const GET_SUB_CATEGORY_TICKET_ERROR = `GET_SUB_CATEGORY_TICKET_ERROR`;
export const GET_SUB_CATEGORY_TICKET_EMPTY = `GET_SUB_CATEGORY_TICKET_EMPTY`;

//GET PRIORITY
export const GET_PRIORITY = `GET_PRIORITY`;
export const GET_PRIORITY_SUCCESS = `GET_PRIORITY_SUCCESS`;
export const GET_PRIORITY_ERROR = `GET_PRIORITY_ERROR`;
export const GET_PRIORITY_EMPTY = `GET_PRIORITY_EMPTY`;

//GET PRIORITY
export const GET_ASSIGNEE = `GET_ASSIGNEE`;
export const GET_ASSIGNEE_SUCCESS = `GET_ASSIGNEE_SUCCESS`;
export const GET_ASSIGNEE_ERROR = `GET_ASSIGNEE_ERROR`;
export const GET_ASSIGNEE_EMPTY = `GET_ASSIGNEE_EMPTY`;

// CREATE TICKET
export const CREATE_TICKET = `CREATE_TICKET`;
export const CREATE_TICKET_SUCCESS = `CREATE_TICKET_SUCCESS`;
export const CREATE_TICKET_ERROR = `CREATE_TICKET_ERROR`;
export const CREATE_TICKET_EMPTY = `CREATE_TICKET_EMPTY`;

// GET TICKET STATUS
export const GET_TICKET_STATUS = `GET_TICKET_STATUS`;
export const GET_TICKET_STATUS_SUCCESS = `GET_TICKET_STATUS_SUCCESS`;
export const GET_TICKET_STATUS_ERROR = `GET_TICKET_STATUS_ERROR`;
export const GET_TICKET_STATUS_EMPTY = `GET_TICKET_STATUS_EMPTY`;

//GET RECENT ACTIVITY
export const GET_RECENT_ACTIVITY = `GET_RECENT_ACTIVITY`;
export const GET_RECENT_ACTIVITY_SUCCESS = `GET_RECENT_ACTIVITY_SUCCESS`;
export const GET_RECENT_ACTIVITY_ERROR = `GET_RECENT_ACTIVITY_ERROR`;
export const GET_RECENT_ACTIVITY_EMPTY = `GET_RECENT_ACTIVITY_EMPTY`;

// GET TICKET ANALYTIC
export const GET_TICKET_ANALYTIC = `GET_TICKET_ANALYTIC`;
export const GET_TICKET_ANALYTIC_SUCCESS = `GET_TICKET_ANALYTIC_SUCCESS`;
export const GET_TICKET_ANALYTIC_ERROR = `GET_TICKET_ANALYTIC_ERROR`;
export const GET_TICKET_ANALYTIC_EMPTY = `GET_TICKET_ANALYTIC_EMPTY`;

//GET REQUIRE TYPES
export const GET_REQUIRE_TYPES = `GET_REQUIRE_TYPES`;
export const GET_REQUIRE_TYPES_SUCCESS = `GET_REQUIRE_TYPES_SUCCESS`;
export const GET_REQUIRE_TYPES_ERROR = `GET_REQUIRE_TYPES_ERROR`;
export const GET_REQUIRE_TYPES_EMPTY = `GET_REQUIRE_TYPES_EMPTY`;

// UPDATE TICKET STATUS
export const UPDATE_TICKET_STATUS = `UPDATE_TICKET_STATUS`;
export const UPDATE_TICKET_STATUS_SUCCESS = `UPDATE_TICKET_STATUS_SUCCESS`;
export const UPDATE_TICKET_STATUS_ERROR = `UPDATE_TICKET_STATUS_ERROR`;
export const UPDATE_TICKET_STATUS_EMPTY = `UPDATE_TICKET_STATUS_EMPTY`;

// UPDATE TICKET ASSIGN
export const UPDATE_TICKET_ASSIGN = `UPDATE_TICKET_ASSIGN`;
export const UPDATE_TICKET_ASSIGN_SUCCESS = `UPDATE_TICKET_ASSIGN_SUCCESS`;
export const UPDATE_TICKET_ASSIGN_ERROR = `UPDATE_TICKET_ASSIGN_ERROR`;
export const UPDATE_TICKET_ASSIGN_EMPTY = `UPDATE_TICKET_ASSIGN_EMPTY`;

// GET COMMENTS
export const GET_COMMENTS = `GET_COMMENTS`;
export const GET_COMMENTS_SUCCESS = `GET_COMMENTS_SUCCESS`;
export const GET_COMMENTS_ERROR = `GET_COMMENTS_ERROR`;
export const GET_COMMENTS_EMPTY = `GET_COMMENTS_EMPTY`;

//save comments
export const SAVE_COMMENTS = `SAVE_COMMENTS`;
export const SAVE_COMMENTS_SUCCESS = `SAVE_COMMENTS_SUCCESS`;
export const SAVE_COMMENTS_ERROR = `SAVE_COMMENTS_ERROR`;
export const SAVE_COMMENTS_EMPTY = `SAVE_COMMENTS_EMPTY`;

//GET BOARD
export const GET_BOARD = `GET_BOARD`;
export const GET_BOARD_SUCCESS = `GET_BOARD_SUCCESS`;
export const GET_BOARD_ERROR = `GET_BOARD_ERROR`;
export const GET_BOARD_EMPTY = `GET_BOARD_EMPTY`;

//GET SLA ASSIGNEE
export const GET_SLA_ASSIGNEE = `GET_SLA_ASSIGNEE`;
export const GET_SLA_ASSIGNEE_SUCCESS = `GET_SLA_ASSIGNEE_SUCCESS`;
export const GET_SLA_ASSIGNEE_ERROR = `GET_SLA_ASSIGNEE_ERROR`;
export const GET_SLA_ASSIGNEE_EMPTY = `GET_SLA_ASSIGNEE_EMPTY`;

export const UPDATE_TICKET_DETAILS = `UPDATE_TICKET_DETAILS`;
export const UPDATE_TICKET_DETAILS_SUCCESS = `UPDATE_TICKET_DETAILS_SUCCESS`;
export const UPDATE_TICKET_DETAILS_ERROR = `UPDATE_TICKET_DETAILS_ERROR`;
export const UPDATE_TICKET_DETAILS_EMPTY = `UPDATE_TICKET_DETAILS_EMPTY`;

// CREATE BULK META
export const CREATE_BULK_META = `CREATE_BULK_META`;
export const CREATE_BULK_META_SUCCESS = `CREATE_BULK_META_SUCCESS`;
export const CREATE_BULK_META_ERROR = `CREATE_BULK_META_ERROR`;
export const CREATE_BULK_META_EMPTY = `CREATE_BULK_META_EMPTY`;

//GET BRAND SERVICE
export const GET_BRAND_SERVICE = `GET_BRAND_SERVICE`;
export const GET_BRAND_SERVICE_SUCCESS = `GET_BRAND_SERVICE_SUCCESS`;
export const GET_BRAND_SERVICE_ERROR = `GET_BRAND_SERVICE_ERROR`;
export const GET_BRAND_SERVICE_EMPTY = `GET_BRAND_SERVICE_EMPTY`;

//EMAIL_PHONE_DRAFT
export const EMAIL_PHONE_DRAFT = `EMAIL_PHONE_DRAFT`;
export const EMAIL_PHONE_DRAFT_SUCCESS = `EMAIL_PHONE_DRAFT_SUCCESS`;
export const EMAIL_PHONE_DRAFT_ERROR = `EMAIL_PHONE_DRAFT_ERROR`;
export const EMAIL_PHONE_DRAFT_EMPTY = `EMAIL_PHONE_DRAFT_EMPTY`;

//ALLOCATE VOUCHER
export const ALLOCATE_VOUCHER = `ALLOCATE_VOUCHER`;
export const ALLOCATE_VOUCHER_SUCCESS = `ALLOCATE_VOUCHER_SUCCESS`;
export const ALLOCATE_VOUCHER_ERROR = `ALLOCATE_VOUCHER_ERROR`;
export const ALLOCATE_VOUCHER_EMPTY = `ALLOCATE_VOUCHER_EMPTY`;

//SUB CATEGORY META
export const SUB_CATEGORY_META = `SUB_CATEGORY_META`;
export const SUB_CATEGORY_META_SUCCESS = `SUB_CATEGORY_META_SUCCESS`;
export const SUB_CATEGORY_META_ERROR = `SUB_CATEGORY_META_ERROR`;
export const SUB_CATEGORY_META_EMPTY = `SUB_CATEGORY_META_EMPTY`;

//REGISTRATION CONFIG
export const REGISTRATION_CONFIG = `REGISTRATION_CONFIG`;
export const REGISTRATION_CONFIG_SUCCESS = `REGISTRATION_CONFIG_SUCCESS`;
export const REGISTRATION_CONFIG_ERROR = `REGISTRATION_CONFIG_ERROR`;
export const REGISTRATION_CONFIG_EMPTY = `REGISTRATION_CONFIG_EMPTY`;

//USER REGISTER 360
export const USER_REGISTER_360 = `USER_REGISTER_360`;
export const USER_REGISTER_360_SUCCESS = `USER_REGISTER_360_SUCCESS`;
export const USER_REGISTER_360_ERROR = `USER_REGISTER_360_ERROR`;
export const USER_REGISTER_360_EMPTY = `USER_REGISTER_360_EMPTY`;

// GET BENEFIT BOOKING
export const GET_BENEFIT_BOOKING = `GET_BENEFIT_BOOKING`;
export const GET_BENEFIT_BOOKING_SUCCESS = `GET_BENEFIT_BOOKING_SUCCESS`;
export const GET_BENEFIT_BOOKING_ERROR = `GET_BENEFIT_BOOKING_ERROR`;
export const GET_BENEFIT_BOOKING_EMPTY = `GET_BENEFIT_BOOKING_EMPTY`;

//CREATE_BOOKING_360
export const CREATE_BOOKING_360 = `CREATE_BOOKING_360`;
export const CREATE_BOOKING_360_SUCCESS = `CREATE_BOOKING_360_SUCCESS`;
export const CREATE_BOOKING_360_ERROR = `CREATE_BOOKING_360_ERROR`;
export const CREATE_BOOKING_360_EMPTY = `CREATE_BOOKING_360_EMPTY`;

// VOUCHER APPROVAL
export const MANUAL_BOOKING_APPROVAL = `MANUAL_BOOKING_APPROVAL`;
export const MANUAL_BOOKING_APPROVAL_SUCCESS = `MANUAL_BOOKING_APPROVAL_SUCCESS`;
export const MANUAL_BOOKING_APPROVAL_ERROR = `MANUAL_BOOKING_APPROVAL_ERROR`;
export const MANUAL_BOOKING_APPROVAL_EMPTY = `MANUAL_BOOKING_APPROVAL_EMPTY`;

//REGISTRATION BENEFIT
export const REGISTRATION_BENEFIT = `REGISTRATION_BENEFIT`;
export const REGISTRATION_BENEFIT_SUCCESS = `REGISTRATION_BENEFIT_SUCCESS`;
export const REGISTRATION_BENEFIT_ERROR = `REGISTRATION_BENEFIT_ERROR`;
export const REGISTRATION_BENEFIT_EMPTY = `REGISTRATION_BENEFIT_EMPTY`;

//SEND COMMUNICATION 360
export const SEND_COMMUNICATION_360 = `SEND_COMMUNICATION_360`;
export const SEND_COMMUNICATION_360_SUCCESS = `SEND_COMMUNICATION_360_SUCCESS`;
export const SEND_COMMUNICATION_360_ERROR = `SEND_COMMUNICATION_360_ERROR`;
export const SEND_COMMUNICATION_360_EMPTY = `SEND_COMMUNICATION_360_EMPTY`;

//UPDATE LABELS
export const UPDATE_LABELS = `UPDATE_LABELS`;
export const UPDATE_LABELS_SUCCESS = `UPDATE_LABELS_SUCCESS`;
export const UPDATE_LABELS_ERROR = `UPDATE_LABELS_ERROR`;
export const UPDATE_LABELS_EMPTY = `UPDATE_LABELS_EMPTY`;

// UPDATE LABELS
export const GET_VENDOR_CONFIGURATION = `GET_VENDOR_CONFIGURATION`;
export const GET_VENDOR_CONFIGURATION_SUCCESS = `GET_VENDOR_CONFIGURATION_SUCCESS`;
export const GET_VENDOR_CONFIGURATION_ERROR = `GET_VENDOR_CONFIGURATION_ERROR`;
export const GET_VENDOR_CONFIGURATION_EMPTY = `GET_VENDOR_CONFIGURATION_EMPTY`;

//GET END SESSION TICKET
export const GET_END_SESSION_TICKET = `GET_END_SESSION_TICKET`;
export const GET_END_SESSION_TICKET_SUCCESS = `GET_END_SESSION_TICKET_SUCCESS`;
export const GET_END_SESSION_TICKET_ERROR = `GET_END_SESSION_TICKET_ERROR`;
export const GET_END_SESSION_TICKET_EMPTY = `GET_END_SESSION_TICKET_EMPTY`;

// GET VENDORS BY AIRPORT REGION ZONE
export const FETCH_VENDORS_BY_REGION = `FETCH_VENDORS_BY_REGION`;
export const FETCH_VENDORS_BY_REGION_SUCCESS = `FETCH_VENDORS_BY_REGION_SUCCESS`;
export const FETCH_VENDORS_BY_REGION_ERROR = `FETCH_VENDORS_BY_REGION_ERROR`;
export const FETCH_VENDORS_BY_REGION_EMPTY = `FETCH_VENDORS_BY_REGION_EMPTY`;

// GET CAR TYPE BY VENDOR
export const GET_CAR_TYPE_BY_VENDOR = `GET_CAR_TYPE_BY_VENDOR`;
export const GET_CAR_TYPE_BY_VENDOR_SUCCESS = `GET_CAR_TYPE_BY_VENDOR_SUCCESS`;
export const GET_CAR_TYPE_BY_VENDOR_ERROR = `GET_CAR_TYPE_BY_VENDOR_ERROR`;
export const GET_CAR_TYPE_BY_VENDOR_EMPTY = `GET_CAR_TYPE_BY_VENDOR_EMPTY`;

// GET CAR TYPE BY VENDOR
export const EXTEND_TIME_SESSION = `EXTEND_TIME_SESSION`;
export const EXTEND_TIME_SESSION_SUCCESS = `EXTEND_TIME_SESSION_SUCCESS`;
export const EXTEND_TIME_SESSION_ERROR = `EXTEND_TIME_SESSION_ERROR`;
export const EXTEND_TIME_SESSION_EMPTY = `EXTEND_TIME_SESSION_EMPTY`;
// GET PROJECT CAMPAIGN
export const GET_PROJECT_CAMPAIGN = `GET_PROJECT_CAMPAIGN`;
export const GET_PROJECT_CAMPAIGN_SUCCESS = `GET_PROJECT_CAMPAIGN_SUCCESS`;
export const GET_PROJECT_CAMPAIGN_ERROR = `GET_PROJECT_CAMPAIGN_ERROR`;
export const GET_PROJECT_CAMPAIGN_EMPTY = `GET_PROJECT_CAMPAIGN_EMPTY`;

// GET CAMPAIGN CONFIGURATION
export const GET_CAMPAIGN_CONFIGURATION = `GET_CAMPAIGN_CONFIGURATION`;
export const GET_CAMPAIGN_CONFIGURATION_SUCCESS = `GET_CAMPAIGN_CONFIGURATION_SUCCESS`;
export const GET_CAMPAIGN_CONFIGURATION_ERROR = `GET_CAMPAIGN_CONFIGURATION_ERROR`;
export const GET_CAMPAIGN_CONFIGURATION_EMPTY = `GET_CAMPAIGN_CONFIGURATION_EMPTY`;

// GET CAMPAIGNS CATALOG
export const GET_CAMPAIGNS_CATALOG = `GET_CAMPAIGNS_CATALOG`;
export const GET_CAMPAIGNS_CATALOG_SUCCESS = `GET_CAMPAIGNS_CATALOG_SUCCESS`;
export const GET_CAMPAIGNS_CATALOG_ERROR = `GET_CAMPAIGNS_CATALOG_ERROR`;
export const GET_CAMPAIGNS_CATALOG_EMPTY = `GET_CAMPAIGNS_CATALOG_EMPTY`;

// PAUSE CAMPAIGN
export const PAUSE_CAMPAIGN = `PAUSE_CAMPAIGN`;
export const PAUSE_CAMPAIGN_SUCCESS = `PAUSE_CAMPAIGN_SUCCESS`;
export const PAUSE_CAMPAIGN_ERROR = `PAUSE_CAMPAIGN_ERROR`;
export const PAUSE_CAMPAIGN_EMPTY = `PAUSE_CAMPAIGN_EMPTY`;

// CREATE CAMPAIGN MANAGEMENT
export const CREATE_CAMPAIGN_MANAGEMENT = `CREATE_CAMPAIGN_MANAGEMENT`;
export const CREATE_CAMPAIGN_MANAGEMENT_SUCCESS = `CREATE_CAMPAIGN_MANAGEMENT_SUCCESS`;
export const CREATE_CAMPAIGN_MANAGEMENT_ERROR = `CREATE_CAMPAIGN_MANAGEMENT_ERROR`;
export const CREATE_CAMPAIGN_MANAGEMENT_EMPTY = `CREATE_CAMPAIGN_MANAGEMENT_EMPTY`;

// LOGOUT CUSTOMER 360
export const EDIT_CAMPAIGN = `EDIT_CAMPAIGN`;
export const EDIT_CAMPAIGN_SUCCESS = `EDIT_CAMPAIGN_SUCCESS`;
export const EDIT_CAMPAIGN_ERROR = `EDIT_CAMPAIGN_ERROR`;
export const EDIT_CAMPAIGN_EMPTY = `EDIT_CAMPAIGN_EMPTY`;

// UPDATE CHAUFFEUR
export const UPDATE_CHAUFFEUR_V2 = `UPDATE_CHAUFFEUR_V2`;
export const UPDATE_CHAUFFEUR_V2_SUCCESS = `UPDATE_CHAUFFEUR_V2_SUCCESS`;
export const UPDATE_CHAUFFEUR_V2_ERROR = `UPDATE_CHAUFFEUR_V2_ERROR`;
export const UPDATE_CHAUFFEUR_V2_EMPTY = `UPDATE_CHAUFFEUR_V2_EMPTY`;

// RESET PASSWORD
export const RESET_PASSWORD_CHAUFFEUR = `RESET_PASSWORD_CHAUFFEUR`;
export const RESET_PASSWORD_CHAUFFEUR_SUCCESS = `RESET_PASSWORD_CHAUFFEUR_SUCCESS`;
export const RESET_PASSWORD_CHAUFFEUR_ERROR = `RESET_PASSWORD_CHAUFFEUR_ERROR`;
export const RESET_PASSWORD_CHAUFFEUR_EMPTY = `RESET_PASSWORD_CHAUFFEUR_EMPTY`;

// CHANGE CHAUFFEUR PASSWORD
export const CHANGE_CHAUFFEUR_PASSWORD = `CHANGE_CHAUFFEUR_PASSWORD`;
export const CHANGE_CHAUFFEUR_PASSWORD_SUCCESS = `CHANGE_CHAUFFEUR_PASSWORD_SUCCESS`;
export const CHANGE_CHAUFFEUR_PASSWORD_ERROR = `CHANGE_CHAUFFEUR_PASSWORD_ERROR`;
export const CHANGE_CHAUFFEUR_PASSWORD_EMPTY = `CHANGE_CHAUFFEUR_PASSWORD_EMPTY`;

// CAMPAIGN SEND FOR APPROVAL
export const CAMPAIGN_SEND_FOR_APPROVAL = `CAMPAIGN_SEND_FOR_APPROVAL`;
export const CAMPAIGN_SEND_FOR_APPROVAL_SUCCESS = `CAMPAIGN_SEND_FOR_APPROVAL_SUCCESS`;
export const CAMPAIGN_SEND_FOR_APPROVAL_ERROR = `CAMPAIGN_SEND_FOR_APPROVAL_ERROR`;
export const CAMPAIGN_SEND_FOR_APPROVAL_EMPTY = `CAMPAIGN_SEND_FOR_APPROVAL_EMPTY`;

// CAMPAIGN MANAGEMENT APPROVAL
export const CAMPAIGN_MANAGEMENT_APPROVAL = `CAMPAIGN_MANAGEMENT_APPROVAL`;
export const CAMPAIGN_MANAGEMENT_APPROVAL_SUCCESS = `CAMPAIGN_MANAGEMENT_APPROVAL_SUCCESS`;
export const CAMPAIGN_MANAGEMENT_APPROVAL_ERROR = `CAMPAIGN_MANAGEMENT_APPROVAL_ERROR`;
export const CAMPAIGN_MANAGEMENT_APPROVAL_EMPTY = `CAMPAIGN_MANAGEMENT_APPROVAL_EMPTY`;

// MEMBERSHIPS REQUEST APPROVAL
export const MEMBERSHIPS_REQUEST_APPROVAL = `MEMBERSHIPS_REQUEST_APPROVAL`;
export const MEMBERSHIPS_REQUEST_APPROVAL_SUCCESS = `MEMBERSHIPS_REQUEST_APPROVAL_SUCCESS`;
export const MEMBERSHIPS_REQUEST_APPROVAL_ERROR = `MEMBERSHIPS_REQUEST_APPROVAL_ERROR`;
export const MEMBERSHIPS_REQUEST_APPROVAL_EMPTY = `MEMBERSHIPS_REQUEST_APPROVAL_EMPTY`;

// SESSION FEEDBACK
export const SESSION_FEEDBACK = `SESSION_FEEDBACK`;
export const SESSION_FEEDBACK_SUCCESS = `SESSION_FEEDBACK_SUCCESS`;
export const SESSION_FEEDBACK_ERROR = `SESSION_FEEDBACK_ERROR`;
export const SESSION_FEEDBACK_EMPTY = `SESSION_FEEDBACK_EMPTY`;

// GET TICKET FILTER
export const GET_TICKET_FILTER = `GET_TICKET_FILTER`;
export const GET_TICKET_FILTER_SUCCESS = `GET_TICKET_FILTER_SUCCESS`;
export const GET_TICKET_FILTER_ERROR = `GET_TICKET_FILTER_ERROR`;
export const GET_TICKET_FILTER_EMPTY = `GET_TICKET_FILTER_EMPTY`;

/* ----------------- PROJECT MANAGEMENT  ----------------- */
// GET BOOKING ANALYTICS
export const GET_BOOKING_ANALYTICS = `GET_BOOKING_ANALYTICS`;
export const GET_BOOKING_ANALYTICS_SUCCESS = `GET_BOOKING_ANALYTICS_SUCCESS`;
export const GET_BOOKING_ANALYTICS_ERROR = `GET_BOOKING_ANALYTICS_ERROR`;
export const GET_BOOKING_ANALYTICS_EMPTY = `GET_BOOKING_ANALYTICS_EMPTY`;

// GET BOOKING ANALYTICS DETAILS
export const GET_BOOKING_ANALYTICS_DETAILS = `GET_BOOKING_ANALYTICS_DETAILS`;
export const GET_BOOKING_ANALYTICS_DETAILS_SUCCESS = `GET_BOOKING_ANALYTICS_DETAILS_SUCCESS`;
export const GET_BOOKING_ANALYTICS_DETAILS_ERROR = `GET_BOOKING_ANALYTICS_DETAILS_ERROR`;
export const GET_BOOKING_ANALYTICS_DETAILS_EMPTY = `GET_BOOKING_ANALYTICS_DETAILS_EMPTY`;

// GET MEMBERSHIPS ANALYTICS
export const GET_MEMBERSHIPS_ANALYTICS = `GET_MEMBERSHIPS_ANALYTICS`;
export const GET_MEMBERSHIPS_ANALYTICS_SUCCESS = `GET_MEMBERSHIPS_ANALYTICS_SUCCESS`;
export const GET_MEMBERSHIPS_ANALYTICS_ERROR = `GET_MEMBERSHIPS_ANALYTICS_ERROR`;
export const GET_MEMBERSHIPS_ANALYTICS_EMPTY = `GET_MEMBERSHIPS_ANALYTICS_EMPTY`;

// GET MEMBERSHIPS ANALYTICS DETAILS
export const GET_MEMBERSHIPS_ANALYTICS_DETAILS = `GET_MEMBERSHIPS_ANALYTICS_DETAILS`;
export const GET_MEMBERSHIPS_ANALYTICS_DETAILS_SUCCESS = `GET_MEMBERSHIPS_ANALYTICS_DETAILS_SUCCESS`;
export const GET_MEMBERSHIPS_ANALYTICS_DETAILS_ERROR = `GET_MEMBERSHIPS_ANALYTICS_DETAILS_ERROR`;
export const GET_MEMBERSHIPS_ANALYTICS_DETAILS_EMPTY = `GET_MEMBERSHIPS_ANALYTICS_DETAILS_EMPTY`;

// GET USER ANALYTICS
export const GET_USERS_ANALYTICS = `GET_USERS_ANALYTICS`;
export const GET_USERS_ANALYTICS_SUCCESS = `GET_USERS_ANALYTICS_SUCCESS`;
export const GET_USERS_ANALYTICS_ERROR = `GET_USERS_ANALYTICS_ERROR`;
export const GET_USERS_ANALYTICS_EMPTY = `GET_USERS_ANALYTICS_EMPTY`;

// GET SFTP USER ANALYTICS
export const GET_SFTP_USERS_ANALYTICS = `GET_SFTP_USERS_ANALYTICS`;
export const GET_SFTP_USERS_ANALYTICS_SUCCESS = `GET_SFTP_USERS_ANALYTICS_SUCCESS`;
export const GET_SFTP_USERS_ANALYTICS_ERROR = `GET_SFTP_USERS_ANALYTICS_ERROR`;
export const GET_SFTP_USERS_ANALYTICS_EMPTY = `GET_SFTP_USERS_ANALYTICS_EMPTY`;

// GET USER ANALYTICS DETAILS
export const GET_USERS_ANALYTICS_DETAILS = `GET_USERS_ANALYTICS_DETAILS`;
export const GET_USERS_ANALYTICS_DETAILS_SUCCESS = `GET_USERS_ANALYTICS_DETAILS_SUCCESS`;
export const GET_USERS_ANALYTICS_DETAILS_ERROR = `GET_USERS_ANALYTICS_DETAILS_ERROR`;
export const GET_USERS_ANALYTICS_DETAILS_EMPTY = `GET_USERS_ANALYTICS_DETAILS_EMPTY`;

// GET PROGRAMS LIST
export const GET_PROGRAMS_LIST = `GET_PROGRAMS_LIST`;
export const GET_PROGRAMS_LIST_SUCCESS = `GET_PROGRAMS_LIST_SUCCESS`;
export const GET_PROGRAMS_LIST_ERROR = `GET_PROGRAMS_LIST_ERROR`;
export const GET_PROGRAMS_LIST_EMPTY = `GET_PROGRAMS_LIST_EMPTY`;

// GET PROGRAM CONFIGS
export const GET_PROGRAM_CONFIGS = `GET_PROGRAM_CONFIGS`;
export const GET_PROGRAM_CONFIGS_SUCCESS = `GET_PROGRAM_CONFIGS_SUCCESS`;
export const GET_PROGRAM_CONFIGS_ERROR = `GET_PROGRAM_CONFIGS_ERROR`;
export const GET_PROGRAM_CONFIGS_EMPTY = `GET_PROGRAM_CONFIGS_EMPTY`;

// GET PROGRAM FILTER CONFIGS
export const GET_PROGRAM_FILTER_CONFIGS = `GET_PROGRAM_FILTER_CONFIGS`;
export const GET_PROGRAM_FILTER_CONFIGS_SUCCESS = `GET_PROGRAM_FILTER_CONFIGS_SUCCESS`;
export const GET_PROGRAM_FILTER_CONFIGS_ERROR = `GET_PROGRAM_FILTER_CONFIGS_ERROR`;
export const GET_PROGRAM_FILTER_CONFIGS_EMPTY = `GET_PROGRAM_FILTER_CONFIGS_EMPTY`;

// GET PROGRAM DETAILS
export const GET_PROGRAM_DETAILS = `GET_PROGRAM_DETAILS`;
export const GET_PROGRAM_DETAILS_SUCCESS = `GET_PROGRAM_DETAILS_SUCCESS`;
export const GET_PROGRAM_DETAILS_ERROR = `GET_PROGRAM_DETAILS_ERROR`;
export const GET_PROGRAM_DETAILS_EMPTY = `GET_PROGRAM_DETAILS_EMPTY`;

//AGENT LIST
export const AGENT_LIST = `AGENT_LIST`;
export const AGENT_LIST_SUCCESS = `AGENT_LIST_SUCCESS`;
export const AGENT_LIST_ERROR = `AGENT_LIST_ERROR`;
export const AGENT_LIST_EMPTY = `AGENT_LIST_EMPTY`;

//OUTGOING SESSION
export const OUTGOING_SESSION = `OUTGOING_SESSION`;
export const OUTGOING_SESSION_SUCCESS = `OUTGOING_SESSION_SUCCESS`;
export const OUTGOING_SESSION_ERROR = `OUTGOING_SESSION_ERROR`;
export const OUTGOING_SESSION_EMPTY = `OUTGOING_SESSION_EMPTY`;

//INCOMING SESSION
export const INCOMING_SESSION = `INCOMING_SESSION`;
export const INCOMING_SESSION_SUCCESS = `INCOMING_SESSION_SUCCESS`;
export const INCOMING_SESSION_ERROR = `INCOMING_SESSION_ERROR`;
export const INCOMING_SESSION_EMPTY = `INCOMING_SESSION_EMPTY`;

//TRANSFER SESSION
export const TRANSFER_SESSION = `TRANSFER_SESSION`;
export const TRANSFER_SESSION_SUCCESS = `TRANSFER_SESSION_SUCCESS`;
export const TRANSFER_SESSION_ERROR = `TRANSFER_SESSION_ERROR`;
export const TRANSFER_SESSION_EMPTY = `TRANSFER_SESSION_EMPTY`;

//ACCEPT_SESSION_TRANSFER
export const ACCEPT_SESSION_TRANSFER = `ACCEPT_SESSION_TRANSFER`;
export const ACCEPT_SESSION_TRANSFER_SUCCESS = `ACCEPT_SESSION_TRANSFER_SUCCESS`;
export const ACCEPT_SESSION_TRANSFER_ERROR = `ACCEPT_SESSION_TRANSFER_ERROR`;
export const ACCEPT_SESSION_TRANSFER_EMPTY = `ACCEPT_SESSION_TRANSFER_EMPTY`;

//REJECT_SESSION_TRANSFER
export const REJECT_SESSION_TRANSFER = `REJECT_SESSION_TRANSFER`;
export const REJECT_SESSION_TRANSFER_SUCCESS = `REJECT_SESSION_TRANSFER_SUCCESS`;
export const REJECT_SESSION_TRANSFER_ERROR = `REJECT_SESSION_TRANSFER_ERROR`;
export const REJECT_SESSION_TRANSFER_EMPTY = `REJECT_SESSION_TRANSFER_EMPTY`;

//UPDATE USER NAME
export const UPDATE_USRNAME = `UPDATE_USRNAME`;
export const UPDATE_USRNAME_SUCCESS = `UPDATE_USRNAME_SUCCESS`;
export const UPDATE_USRNAME_ERROR = `UPDATE_USRNAME_ERROR`;
export const UPDATE_USRNAME_EMPTY = `UPDATE_USRNAME_EMPTY`;

//UPDATE USER NAME
export const VERIFY_AND_SENT_OTP = `VERIFY_AND_SENT_OTP`;
export const VERIFY_AND_SENT_OTP_SUCCESS = `VERIFY_AND_SENT_OTP_SUCCESS`;
export const VERIFY_AND_SENT_OTP_ERROR = `VERIFY_AND_SENT_OTP_ERROR`;
export const VERIFY_AND_SENT_OTP_EMPTY = `VERIFY_AND_SENT_OTP_EMPTY`;

//UPDATE USER NAME
export const VERIFY_OTP = `VERIFY_OTP`;
export const VERIFY_OTP_SUCCESS = `VERIFY_OTP_SUCCESS`;
export const VERIFY_OTP_ERROR = `VERIFY_OTP_ERROR`;
export const VERIFY_OTP_EMPTY = `VERIFY_OTP_EMPTY`;

//UPDATE USER NAME
export const VERIFY_EMAIL = `VERIFY_EMAIL`;
export const VERIFY_EMAIL_SUCCESS = `VERIFY_EMAIL_SUCCESS`;
export const VERIFY_EMAIL_ERROR = `VERIFY_EMAIL_ERROR`;
export const VERIFY_EMAIL_EMPTY = `VERIFY_EMAIL_EMPTY`;

// GET PROGRAM MEMBERSHIPS STATS
export const GET_PROGRAM_MEMBERSHIPS_STATS = `GET_PROGRAM_MEMBERSHIPS_STATS`;
export const GET_PROGRAM_MEMBERSHIPS_STATS_SUCCESS = `GET_PROGRAM_MEMBERSHIPS_STATS_SUCCESS`;
export const GET_PROGRAM_MEMBERSHIPS_STATS_ERROR = `GET_PROGRAM_MEMBERSHIPS_STATS_ERROR`;
export const GET_PROGRAM_MEMBERSHIPS_STATS_EMPTY = `GET_PROGRAM_MEMBERSHIPS_STATS_EMPTY`;

// GET MEMBERSHIPS BIN MONTHLY STATS
export const GET_MEMBERSHIPS_BIN_MONTHLY_STATS = `GET_MEMBERSHIPS_BIN_MONTHLY_STATS`;
export const GET_MEMBERSHIPS_BIN_MONTHLY_STATS_SUCCESS = `GET_MEMBERSHIPS_BIN_MONTHLY_STATS_SUCCESS`;
export const GET_MEMBERSHIPS_BIN_MONTHLY_STATS_ERROR = `GET_MEMBERSHIPS_BIN_MONTHLY_STATS_ERROR`;
export const GET_MEMBERSHIPS_BIN_MONTHLY_STATS_EMPTY = `GET_MEMBERSHIPS_BIN_MONTHLY_STATS_EMPTY`;

//SEND EMAIL COMMUNICATION
export const SEND_EMAIL_COMMUNICATION = `SEND_EMAIL_COMMUNICATION`;
export const SEND_EMAIL_COMMUNICATION_SUCCESS = `SEND_EMAIL_COMMUNICATION_SUCCESS`;
export const SEND_EMAIL_COMMUNICATION_ERROR = `SEND_EMAIL_COMMUNICATION_ERROR`;
export const SEND_EMAIL_COMMUNICATION_EMPTY = `SEND_EMAIL_COMMUNICATION_EMPTY`;

//FORWARD EMAIL COMMUNICATION
export const FORWARD_EMAIL_COMMUNICATION = `FORWARD_EMAIL_COMMUNICATION`;
export const FORWARD_EMAIL_COMMUNICATION_SUCCESS = `FORWARD_EMAIL_COMMUNICATION_SUCCESS`;
export const FORWARD_EMAIL_COMMUNICATION_ERROR = `FORWARD_EMAIL_COMMUNICATION_ERROR`;
export const FORWARD_EMAIL_COMMUNICATION_EMPTY = `FORWARD_EMAIL_COMMUNICATION_EMPTY`;

//FORWARD EMAIL COMMUNICATION
export const SEND_WHATSAPP = `SEND_WHATSAPP`;
export const SEND_WHATSAPP_SUCCESS = `SEND_WHATSAPP_SUCCESS`;
export const SEND_WHATSAPP_ERROR = `SEND_WHATSAPP_ERROR`;
export const SEND_WHATSAPP_EMPTY = `SEND_WHATSAPP_EMPTY`;

//GET_COMMUNICATION_TEMPLATE
export const GET_COMMUNICATION_TEMPLATE = `GET_COMMUNICATION_TEMPLATE`;
export const GET_COMMUNICATION_TEMPLATE_SUCCESS = `GET_COMMUNICATION_TEMPLATE_SUCCESS`;
export const GET_COMMUNICATION_TEMPLATE_ERROR = `GET_COMMUNICATION_TEMPLATE_ERROR`;
export const GET_COMMUNICATION_TEMPLATE_EMPTY = `GET_COMMUNICATION_TEMPLATE_EMPTY`;

//GET_WHATSAPP_TEMPLATE
export const GET_WHATSAPP_TEMPLATE = `GET_WHATSAPP_TEMPLATE`;
export const GET_WHATSAPP_TEMPLATE_SUCCESS = `GET_WHATSAPP_TEMPLATE_SUCCESS`;
export const GET_WHATSAPP_TEMPLATE_ERROR = `GET_WHATSAPP_TEMPLATE_ERROR`;
export const GET_WHATSAPP_TEMPLATE_EMPTY = `GET_WHATSAPP_TEMPLATE_EMPTY`;

//FORWARD EMAIL COMMUNICATION
export const LINK_CUSTOMER = `LINK_CUSTOMER`;
export const LINK_CUSTOMER_SUCCESS = `LINK_CUSTOMER_SUCCESS`;
export const LINK_CUSTOMER_ERROR = `LINK_CUSTOMER_ERROR`;
export const LINK_CUSTOMER_EMPTY = `LINK_CUSTOMER_EMPTY`;

//SAVE FILTERS
export const SAVE_FILTERS = `SAVE_FILTERS`;
export const SAVE_FILTERS_SUCCESS = `SAVE_FILTERS_SUCCESS`;
export const SAVE_FILTERS_ERROR = `SAVE_FILTERS_ERROR`;
export const SAVE_FILTERS_EMPTY = `SAVE_FILTERS_EMPTY`;

// USER PENDING REQUEST COUNT
export const USER_PENDING_REQUEST_COUNT = `USER_PENDING_REQUEST_COUNT`;
export const USER_PENDING_REQUEST_COUNT_SUCCESS = `USER_PENDING_REQUEST_COUNT_SUCCESS`;
export const USER_PENDING_REQUEST_COUNT_ERROR = `USER_PENDING_REQUEST_COUNT_ERROR`;
export const USER_PENDING_REQUEST_COUNT_EMPTY = `USER_PENDING_REQUEST_COUNT_EMPTY`;

// USER PENDING REQUEST COUNT
export const GET_GOLF_INVENTORY_TYPE = `GET_GOLF_INVENTORY_TYPE`;
export const GET_GOLF_INVENTORY_TYPE_SUCCESS = `GET_GOLF_INVENTORY_TYPE_SUCCESS`;
export const GET_GOLF_INVENTORY_TYPE_ERROR = `GET_GOLF_INVENTORY_TYPE_ERROR`;
export const GET_GOLF_INVENTORY_TYPE_EMPTY = `GET_GOLF_INVENTORY_TYPE_EMPTY`;

// CREATE GOLF INVENTORY
export const CREATE_GOLF_INVENTORY = `CREATE_GOLF_INVENTORY`;
export const CREATE_GOLF_INVENTORY_SUCCESS = `CREATE_GOLF_INVENTORY_SUCCESS`;
export const CREATE_GOLF_INVENTORY_ERROR = `CREATE_GOLF_INVENTORY_ERROR`;
export const CREATE_GOLF_INVENTORY_EMPTY = `CREATE_GOLF_INVENTORY_EMPTY`;

// GET COMMS STATS
export const GET_COMMS_STATS = `GET_COMMS_STATS`;
export const GET_COMMS_STATS_SUCCESS = `GET_COMMS_STATS_SUCCESS`;
export const GET_COMMS_STATS_ERROR = `GET_COMMS_STATS_ERROR`;
export const GET_COMMS_STATS_EMPTY = `GET_COMMS_STATS_EMPTY`;

// GET COMMS SUMMARY (templates listing + metrics + filter options)
export const GET_COMMS_SUMMARY = `GET_COMMS_SUMMARY`;
export const GET_COMMS_SUMMARY_SUCCESS = `GET_COMMS_SUMMARY_SUCCESS`;
export const GET_COMMS_SUMMARY_ERROR = `GET_COMMS_SUMMARY_ERROR`;
export const GET_COMMS_SUMMARY_EMPTY = `GET_COMMS_SUMMARY_EMPTY`;
// GET BLOCK LIST
export const GET_BLOCK_DATE_LIST = `GET_BLOCK_DATE_LIST`;
export const GET_BLOCK_DATE_LIST_SUCCESS = `GET_BLOCK_DATE_LIST_SUCCESS`;
export const GET_BLOCK_DATE_LIST_ERROR = `GET_BLOCK_DATE_LIST_ERROR`;
export const GET_BLOCK_DATE_LIST_EMPTY = `GET_BLOCK_DATE_LIST_EMPTY`;

// CREATE BLOCK DATE
export const CREATE_BLOCK_DATE = `CREATE_BLOCK_DATE`;
export const CREATE_BLOCK_DATE_SUCCESS = `CREATE_BLOCK_DATE_SUCCESS`;
export const CREATE_BLOCK_DATE_ERROR = `CREATE_BLOCK_DATE_ERROR`;
export const CREATE_BLOCK_DATE_EMPTY = `CREATE_BLOCK_DATE_EMPTY`;

// UPDATE BLOCK DATE
export const UPDATE_BLOCK_DATE = `UPDATE_BLOCK_DATE`;
export const UPDATE_BLOCK_DATE_SUCCESS = `UPDATE_BLOCK_DATE_SUCCESS`;
export const UPDATE_BLOCK_DATE_ERROR = `UPDATE_BLOCK_DATE_ERROR`;
export const UPDATE_BLOCK_DATE_EMPTY = `UPDATE_BLOCK_DATE_EMPTY`;

// UPDATE BLOCK DATE
export const BLOCK_UNBLOCK_DATE = `BLOCK_UNBLOCK_DATE`;
export const BLOCK_UNBLOCK_DATE_SUCCESS = `BLOCK_UNBLOCK_DATE_SUCCESS`;
export const BLOCK_UNBLOCK_DATE_ERROR = `BLOCK_UNBLOCK_DATE_ERROR`;
export const BLOCK_UNBLOCK_DATE_EMPTY = `BLOCK_UNBLOCK_DATE_EMPTY`;

// GET FACILITY HOLIDAY LIST
export const GET_FACILITY_HOLIDAY_LIST = `GET_FACILITY_HOLIDAY_LIST`;
export const GET_FACILITY_HOLIDAY_LIST_SUCCESS = `GET_FACILITY_HOLIDAY_LIST_SUCCESS`;
export const GET_FACILITY_HOLIDAY_LIST_ERROR = `GET_FACILITY_HOLIDAY_LIST_ERROR`;
export const GET_FACILITY_HOLIDAY_LIST_EMPTY = `GET_FACILITY_HOLIDAY_LIST_EMPTY`;

// CREATE FACILITY HOLIDAY
export const CREATE_FACILITY_HOLIDAY = `CREATE_FACILITY_HOLIDAY`;
export const CREATE_FACILITY_HOLIDAY_SUCCESS = `CREATE_FACILITY_HOLIDAY_SUCCESS`;
export const CREATE_FACILITY_HOLIDAY_ERROR = `CREATE_FACILITY_HOLIDAY_ERROR`;
export const CREATE_FACILITY_HOLIDAY_EMPTY = `CREATE_FACILITY_HOLIDAY_EMPTY`;

// UPDATE FACILITY HOLIDAY
export const UPDATE_FACILITY_HOLIDAY = `UPDATE_FACILITY_HOLIDAY`;
export const UPDATE_FACILITY_HOLIDAY_SUCCESS = `UPDATE_FACILITY_HOLIDAY_SUCCESS`;
export const UPDATE_FACILITY_HOLIDAY_ERROR = `UPDATE_FACILITY_HOLIDAY_ERROR`;
export const UPDATE_FACILITY_HOLIDAY_EMPTY = `UPDATE_FACILITY_HOLIDAY_EMPTY`;

// DELETE FACILITY HOLIDAY
export const DELETE_FACILITY_HOLIDAY = `DELETE_FACILITY_HOLIDAY`;
export const DELETE_FACILITY_HOLIDAY_SUCCESS = `DELETE_FACILITY_HOLIDAY_SUCCESS`;
export const DELETE_FACILITY_HOLIDAY_ERROR = `DELETE_FACILITY_HOLIDAY_ERROR`;
export const DELETE_FACILITY_HOLIDAY_EMPTY = `DELETE_FACILITY_HOLIDAY_EMPTY`;

// FACILITY HOLIDAY APPROVAL
export const APPROVAL_FACILITY_HOLIDAY = `APPROVAL_FACILITY_HOLIDAY`;
export const APPROVAL_FACILITY_HOLIDAY_SUCCESS = `APPROVAL_FACILITY_HOLIDAY_SUCCESS`;
export const APPROVAL_FACILITY_HOLIDAY_ERROR = `APPROVAL_FACILITY_HOLIDAY_ERROR`;
export const APPROVAL_FACILITY_HOLIDAY_EMPTY = `APPROVAL_FACILITY_HOLIDAY_EMPTY`;

// BLOCK DATE APPROVAL
export const APPROVAL_BLOCK_DATE = `APPROVAL_BLOCK_DATE`;
export const APPROVAL_BLOCK_DATE_SUCCESS = `APPROVAL_BLOCK_DATE_SUCCESS`;
export const APPROVAL_BLOCK_DATE_ERROR = `APPROVAL_BLOCK_DATE_ERROR`;
export const APPROVAL_BLOCK_DATE_EMPTY = `APPROVAL_BLOCK_DATE_EMPTY`;

// GET QUOTA DETAILS
export const GET_QUOTA_DETAILS = `GET_QUOTA_DETAILS`;
export const GET_QUOTA_DETAILS_SUCCESS = `GET_QUOTA_DETAILS_SUCCESS`;
export const GET_QUOTA_DETAILS_ERROR = `GET_QUOTA_DETAILS_ERROR`;
export const GET_QUOTA_DETAILS_EMPTY = `GET_QUOTA_DETAILS_EMPTY`;

export const GET_GM_CURRENCY = `GET_GM_CURRENCY`;
export const GET_GM_CURRENCY_SUCCESS = `GET_GM_CURRENCY_SUCCESS`;
export const GET_GM_CURRENCY_ERROR = `GET_GM_CURRENCY_ERROR`;
export const GET_GM_CURRENCY_EMPTY = `GET_GM_CURRENCY_EMPTY`;

export const GET_GM_COUNTRY = `GET_GM_COUNTRY`;
export const GET_GM_COUNTRY_SUCCESS = `GET_GM_COUNTRY_SUCCESS`;
export const GET_GM_COUNTRY_ERROR = `GET_GM_COUNTRY_ERROR`;
export const GET_GM_COUNTRY_EMPTY = `GET_GM_COUNTRY_EMPTY`;

export const GET_GM_PROJECTS = `GET_GM_PROJECTS`;
export const GET_GM_PROJECTS_SUCCESS = `GET_GM_PROJECTS_SUCCESS`;
export const GET_GM_PROJECTS_ERROR = `GET_GM_PROJECTS_ERROR`;
export const GET_GM_PROJECTS_EMPTY = `GET_GM_PROJECTS_EMPTY`;

// GET REASON FOR BLOCK DATE
export const GET_REASON_FOR_BLOCK_DATE = `GET_REASON_FOR_BLOCK_DATE`;
export const GET_REASON_FOR_BLOCK_DATE_SUCCESS = `GET_REASON_FOR_BLOCK_DATE_SUCCESS`;
export const GET_REASON_FOR_BLOCK_DATE_ERROR = `GET_REASON_FOR_BLOCK_DATE_ERROR`;
export const GET_REASON_FOR_BLOCK_DATE_EMPTY = `GET_REASON_FOR_BLOCK_DATE_EMPTY`;

//CLIENT PANEL AUTHENTICATION
export const CLIENT_PANEL_AUTHENTICATION = `CLIENT_PANEL_AUTHENTICATION`;
export const CLIENT_PANEL_AUTHENTICATION_SUCCESS = `CLIENT_PANEL_AUTHENTICATION_SUCCESS`;
export const CLIENT_PANEL_AUTHENTICATION_ERROR = `CLIENT_PANEL_AUTHENTICATION_ERROR`;
export const CLIENT_PANEL_AUTHENTICATION_EMPTY = `CLIENT_PANEL_AUTHENTICATION_EMPTY`;

export const SEARCH_CLIENT_PANEL = `SEARCH_CLIENT_PANEL`;
export const SEARCH_CLIENT_PANEL_SUCCESS = `SEARCH_CLIENT_PANEL_SUCCESS`;
export const SEARCH_CLIENT_PANEL_ERROR = `SEARCH_CLIENT_PANEL_ERROR`;
export const SEARCH_CLIENT_PANEL_EMPTY = `SEARCH_CLIENT_PANEL_EMPTY`;

export const LOGOUT_CLIENT_PANEL = `LOGOUT_CLIENT_PANEL`;
export const LOGOUT_CLIENT_PANEL_SUCCESS = `LOGOUT_CLIENT_PANEL_SUCCESS`;
export const LOGOUT_CLIENT_PANEL_ERROR = `LOGOUT_CLIENT_PANEL_ERROR`;
export const LOGOUT_CLIENT_PANEL_EMPTY = `LOGOUT_CLIENT_PANEL_EMPTY`;

/* ----------------- Get Download Dump ----------------- */
export const GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2 = `GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2`;
export const GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS = `GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS`;
export const GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR = `GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR`;
export const GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_EMPTY = `GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_EMPTY`;

export const DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2 = `DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2`;
export const DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS = `DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS`;
export const DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR = `DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR`;
export const DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_EMPTY = `DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_EMPTY`;

export const V2_CLIENT_FORGOT_PASSWORD = `V2_CLIENT_FORGOT_PASSWORD`;
export const V2_CLIENT_FORGOT_PASSWORD_SUCCESS = `V2_CLIENT_FORGOT_PASSWORD_SUCCESS`;
export const V2_CLIENT_FORGOT_PASSWORD_ERROR = `V2_CLIENT_FORGOT_PASSWORD_ERROR`;
export const V2_CLIENT_FORGOT_PASSWORD_EMPTY = `V2_CLIENT_FORGOT_PASSWORD_EMPTY`;

export const CLIENT_LOGIN_V2 = `CLIENT_LOGIN_V2`;
export const CLIENT_LOGIN_V2_SUCCESS = `CLIENT_LOGIN_V2_SUCCESS`;
export const CLIENT_LOGIN_V2_ERROR = `CLIENT_LOGIN_V2_ERROR`;
export const CLIENT_LOGIN_V2_EMPTY = `CLIENT_LOGIN_V2_EMPTY`;

export const CLIENT_RESET_PASSWORD_V2 = `CLIENT_RESET_PASSWORD_V2`;
export const CLIENT_RESET_PASSWORD_V2_SUCCESS = `CLIENT_RESET_PASSWORD_V2_SUCCESS`;
export const CLIENT_RESET_PASSWORD_V2_ERROR = `CLIENT_RESET_PASSWORD_V2_ERROR`;
export const CLIENT_RESET_PASSWORD_V2_EMPTY = `CLIENT_RESET_PASSWORD_V2_EMPTY`;

export const VALIDATE_TOKEN_V2 = `VALIDATE_TOKEN_V2`;
export const VALIDATE_TOKEN_V2_SUCCESS = `VALIDATE_TOKEN_V2_SUCCESS`;
export const VALIDATE_TOKEN_V2_ERROR = `VALIDATE_TOKEN_V2_ERROR`;
export const VALIDATE_TOKEN_V2_EMPTY = `VALIDATE_TOKEN_V2_EMPTY`;

//aina 360
export const GET_BENEFIT_TYPE = `GET_BENEFIT_TYPE`;
export const GET_BENEFIT_TYPE_SUCCESS = `GET_BENEFIT_TYPE_SUCCESS`;
export const GET_BENEFIT_TYPE_ERROR = `GET_BENEFIT_TYPE_ERROR`;
export const GET_BENEFIT_TYPE_EMPTY = `GET_BENEFIT_TYPE_EMPTY`;

export const GET_PLATFORM = `GET_PLATFORM`;
export const GET_PLATFORM_SUCCESS = `GET_PLATFORM_SUCCESS`;
export const GET_PLATFORM_ERROR = `GET_PLATFORM_ERROR`;
export const GET_PLATFORM_EMPTY = `GET_PLATFORM_EMPTY`;

export const GET_SERVICE_TYPE = `GET_SERVICE_TYPE`;
export const GET_SERVICE_TYPE_SUCCESS = `GET_SERVICE_TYPE_SUCCESS`;
export const GET_SERVICE_TYPE_ERROR = `GET_SERVICE_TYPE_ERROR`;
export const GET_SERVICE_TYPE_EMPTY = `GET_SERVICE_TYPE_EMPTY`;

export const ACKNOWLEDGE_CLOSURE = `ACKNOWLEDGE_CLOSURE`;
export const ACKNOWLEDGE_CLOSURE_SUCCESS = `ACKNOWLEDGE_CLOSURE_SUCCESS`;
export const ACKNOWLEDGE_CLOSURE_ERROR = `ACKNOWLEDGE_CLOSURE_ERROR`;
export const ACKNOWLEDGE_CLOSURE_EMPTY = `ACKNOWLEDGE_CLOSURE_EMPTY`;

export const SEND_CHAT = `SEND_CHAT`;
export const SEND_CHAT_SUCCESS = `SEND_CHAT_SUCCESS`;
export const SEND_CHAT_ERROR = `SEND_CHAT_ERROR`;
export const SEND_CHAT_EMPTY = `SEND_CHAT_EMPTY`;

export const SHOW_MESSAGE = `SHOW_MESSAGE`;
export const SHOW_MESSAGE_SUCCESS = `SHOW_MESSAGE_SUCCESS`;
export const SHOW_MESSAGE_ERROR = `SHOW_MESSAGE_ERROR`;
export const SHOW_MESSAGE_EMPTY = `SHOW_MESSAGE_EMPTY`;

export const HIDE_MESSAGE = `HIDE_MESSAGE`;
export const HIDE_MESSAGE_SUCCESS = `HIDE_MESSAGE_SUCCESS`;
export const HIDE_MESSAGE_ERROR = `HIDE_MESSAGE_ERROR`;
export const HIDE_MESSAGE_EMPTY = `HIDE_MESSAGE_EMPTY`;

/* ----------------- GET BOOKING TYPE FOR TICKET MANAGEMENT ----------------- */
export const GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT = `GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT`;
export const GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_SUCCESS = `GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_SUCCESS`;
export const GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_ERROR = `GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_ERROR`;
export const GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_EMPTY = `GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_EMPTY`;

//gmpricing
export const SAAS_SAVE_DRAFT = `SAAS_SAVE_DRAFT`;
export const SAAS_SAVE_DRAFT_SUCCESS = `SAAS_SAVE_DRAFT_SUCCESS`;
export const SAAS_SAVE_DRAFT_ERROR = `SAAS_SAVE_DRAFT_ERROR`;
export const SAAS_SAVE_DRAFT_EMPTY = `SAAS_SAVE_DRAFT_EMPTY`;

export const SAAS_CONFIRM = `SAAS_CONFIRM`;
export const SAAS_CONFIRM_SUCCESS = `SAAS_CONFIRM_SUCCESS`;
export const SAAS_CONFIRM_ERROR = `SAAS_CONFIRM_ERROR`;
export const SAAS_CONFIRM_EMPTY = `SAAS_CONFIRM_EMPTY`;

export const GM_PRICE_APPROVAL = `GM_PRICE_APPROVAL`;
export const GM_PRICE_APPROVAL_SUCCESS = `GM_PRICE_APPROVAL_SUCCESS`;
export const GM_PRICE_APPROVAL_ERROR = `GM_PRICE_APPROVAL_ERROR`;
export const GM_PRICE_APPROVAL_EMPTY = `GM_PRICE_APPROVAL_EMPTY`;

export const EVENTS_SAVE_DRAFT = `EVENTS_SAVE_DRAFT`;
export const EVENTS_SAVE_DRAFT_SUCCESS = `EVENTS_SAVE_DRAFT_SUCCESS`;
export const EVENTS_SAVE_DRAFT_ERROR = `EVENTS_SAVE_DRAFT_ERROR`;
export const EVENTS_SAVE_DRAFT_EMPTY = `EVENTS_SAVE_DRAFT_EMPTY`;

export const EVENTS_CONFIRM = `EVENTS_CONFIRM`;
export const EVENTS_CONFIRM_SUCCESS = `EVENTS_CONFIRM_SUCCESS`;
export const EVENTS_CONFIRM_ERROR = `EVENTS_CONFIRM_ERROR`;
export const EVENTS_CONFIRM_EMPTY = `EVENTS_CONFIRM_EMPTY`;

export const DIGITAL_SAVE_DRAFT = `DIGITAL_SAVE_DRAFT`;
export const DIGITAL_SAVE_DRAFT_SUCCESS = `DIGITAL_SAVE_DRAFT_SUCCESS`;
export const DIGITAL_SAVE_DRAFT_ERROR = `DIGITAL_SAVE_DRAFT_ERROR`;
export const DIGITAL_SAVE_DRAFT_EMPTY = `DIGITAL_SAVE_DRAFT_EMPTY`;

export const DIGITAL_CONFIRM = `DIGITAL_CONFIRM`;
export const DIGITAL_CONFIRM_SUCCESS = `DIGITAL_CONFIRM_SUCCESS`;
export const DIGITAL_CONFIRM_ERROR = `DIGITAL_CONFIRM_ERROR`;
export const DIGITAL_CONFIRM_EMPTY = `DIGITAL_CONFIRM_EMPTY`;
export const GET_GM_CAMPAIGNS = `GET_GM_CAMPAIGNS`;
export const GET_GM_CAMPAIGNS_SUCCESS = `GET_GM_CAMPAIGNS_SUCCESS`;
export const GET_GM_CAMPAIGNS_ERROR = `GET_GM_CAMPAIGNS_ERROR`;
export const GET_GM_CAMPAIGNS_EMPTY = `GET_GM_CAMPAIGNS_EMPTY`;

// QUOTA REVERSAL
export const GET_UTILITY_REQUEST_CARD_STATES = `GET_UTILITY_REQUEST_CARD_STATES`;
export const GET_UTILITY_REQUEST_CARD_STATES_SUCCESS = `GET_UTILITY_REQUEST_CARD_STATES_SUCCESS`;
export const GET_UTILITY_REQUEST_CARD_STATES_ERROR = `GET_UTILITY_REQUEST_CARD_STATES_ERROR`;
export const GET_UTILITY_REQUEST_CARD_STATES_EMPTY = `GET_UTILITY_REQUEST_CARD_STATES_EMPTY`;

export const GET_UTILITY_REQUEST_ISSUE_TYPES = `GET_UTILITY_REQUEST_ISSUE_TYPES`;
export const GET_UTILITY_REQUEST_ISSUE_TYPES_SUCCESS = `GET_UTILITY_REQUEST_ISSUE_TYPES_SUCCESS`;
export const GET_UTILITY_REQUEST_ISSUE_TYPES_ERROR = `GET_UTILITY_REQUEST_ISSUE_TYPES_ERROR`;
export const GET_UTILITY_REQUEST_ISSUE_TYPES_EMPTY = `GET_UTILITY_REQUEST_ISSUE_TYPES_EMPTY`;

export const UPLOAD_UTILITY_ATTACHMENT = `UPLOAD_UTILITY_ATTACHMENT`;
export const UPLOAD_UTILITY_ATTACHMENT_SUCCESS = `UPLOAD_UTILITY_ATTACHMENT_SUCCESS`;
export const UPLOAD_UTILITY_ATTACHMENT_ERROR = `UPLOAD_UTILITY_ATTACHMENT_ERROR`;
export const UPLOAD_UTILITY_ATTACHMENT_EMPTY = `UPLOAD_UTILITY_ATTACHMENT_EMPTY`;

export const GET_UTILITY_REQUEST_PROJECTS = `GET_UTILITY_REQUEST_PROJECTS`;
export const GET_UTILITY_REQUEST_PROJECTS_SUCCESS = `GET_UTILITY_REQUEST_PROJECTS_SUCCESS`;
export const GET_UTILITY_REQUEST_PROJECTS_ERROR = `GET_UTILITY_REQUEST_PROJECTS_ERROR`;
export const GET_UTILITY_REQUEST_PROJECTS_EMPTY = `GET_UTILITY_REQUEST_PROJECTS_EMPTY`;

export const GET_UTILITY_BOOKING_DETAILS = `GET_UTILITY_BOOKING_DETAILS`;
export const GET_UTILITY_BOOKING_DETAILS_SUCCESS = `GET_UTILITY_BOOKING_DETAILS_SUCCESS`;
export const GET_UTILITY_BOOKING_DETAILS_ERROR = `GET_UTILITY_BOOKING_DETAILS_ERROR`;
export const GET_UTILITY_BOOKING_DETAILS_EMPTY = `GET_UTILITY_BOOKING_DETAILS_EMPTY`;

export const CREATE_UTILITY_REQUEST = `CREATE_UTILITY_REQUEST`;
export const CREATE_UTILITY_REQUEST_SUCCESS = `CREATE_UTILITY_REQUEST_SUCCESS`;
export const CREATE_UTILITY_REQUEST_ERROR = `CREATE_UTILITY_REQUEST_ERROR`;
export const CREATE_UTILITY_REQUEST_EMPTY = `CREATE_UTILITY_REQUEST_EMPTY`;

export const VALIDATE_UTILITY_ATTACHMENTS = `VALIDATE_UTILITY_ATTACHMENTS`;
export const VALIDATE_UTILITY_ATTACHMENTS_SUCCESS = `VALIDATE_UTILITY_ATTACHMENTS_SUCCESS`;
export const VALIDATE_UTILITY_ATTACHMENTS_ERROR = `VALIDATE_UTILITY_ATTACHMENTS_ERROR`;
export const VALIDATE_UTILITY_ATTACHMENTS_EMPTY = `VALIDATE_UTILITY_ATTACHMENTS_EMPTY`;

export const APPROVAL_ACTION_UTILITY_REQUEST = `APPROVAL_ACTION_UTILITY_REQUEST`;
export const APPROVAL_ACTION_UTILITY_REQUEST_SUCCESS = `APPROVAL_ACTION_UTILITY_REQUEST_SUCCESS`;
export const APPROVAL_ACTION_UTILITY_REQUEST_ERROR = `APPROVAL_ACTION_UTILITY_REQUEST_ERROR`;
export const APPROVAL_ACTION_UTILITY_REQUEST_EMPTY = `APPROVAL_ACTION_UTILITY_REQUEST_EMPTY`;

export const GET_UTILITY_REQUEST_DETAILS = `GET_UTILITY_REQUEST_DETAILS`;
export const GET_UTILITY_REQUEST_DETAILS_SUCCESS = `GET_UTILITY_REQUEST_DETAILS_SUCCESS`;
export const GET_UTILITY_REQUEST_DETAILS_ERROR = `GET_UTILITY_REQUEST_DETAILS_ERROR`;
export const GET_UTILITY_REQUEST_DETAILS_EMPTY = `GET_UTILITY_REQUEST_DETAILS_EMPTY`;

export const DOWNLOAD_UTILITY_SAMPLE_EXCEL = `DOWNLOAD_UTILITY_SAMPLE_EXCEL`;
export const DOWNLOAD_UTILITY_SAMPLE_EXCEL_SUCCESS = `DOWNLOAD_UTILITY_SAMPLE_EXCEL_SUCCESS`;
export const DOWNLOAD_UTILITY_SAMPLE_EXCEL_ERROR = `DOWNLOAD_UTILITY_SAMPLE_EXCEL_ERROR`;
export const DOWNLOAD_UTILITY_SAMPLE_EXCEL_EMPTY = `DOWNLOAD_UTILITY_SAMPLE_EXCEL_EMPTY`;

export const DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL = `DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL`;
export const DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_SUCCESS = `DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_SUCCESS`;
export const DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_ERROR = `DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_ERROR`;
export const DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_EMPTY = `DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_EMPTY`;

export const GET_MANUAL_FACILITIES = `GET_MANUAL_FACILITIES`;
export const GET_MANUAL_FACILITIES_SUCCESS = `GET_MANUAL_FACILITIES_SUCCESS`;
export const GET_MANUAL_FACILITIES_ERROR = `GET_MANUAL_FACILITIES_ERROR`;
export const GET_MANUAL_FACILITIES_EMPTY = `GET_MANUAL_FACILITIES_EMPTY`;

export const GET_MANUAL_GOLF_COACHES = `GET_MANUAL_GOLF_COACHES`;
export const GET_MANUAL_GOLF_COACHES_SUCCESS = `GET_MANUAL_GOLF_COACHES_SUCCESS`;
export const GET_MANUAL_GOLF_COACHES_ERROR = `GET_MANUAL_GOLF_COACHES_ERROR`;
export const GET_MANUAL_GOLF_COACHES_EMPTY = `GET_MANUAL_GOLF_COACHES_EMPTY`;

export const SAVE_MANUAL_BOOKING_DRAFT = `SAVE_MANUAL_BOOKING_DRAFT`;
export const SAVE_MANUAL_BOOKING_DRAFT_SUCCESS = `SAVE_MANUAL_BOOKING_DRAFT_SUCCESS`;
export const SAVE_MANUAL_BOOKING_DRAFT_ERROR = `SAVE_MANUAL_BOOKING_DRAFT_ERROR`;
export const SAVE_MANUAL_BOOKING_DRAFT_EMPTY = `SAVE_MANUAL_BOOKING_DRAFT_EMPTY`;

export const SUBMIT_MANUAL_BOOKING_APPROVAL = `SUBMIT_MANUAL_BOOKING_APPROVAL`;
export const SUBMIT_MANUAL_BOOKING_APPROVAL_SUCCESS = `SUBMIT_MANUAL_BOOKING_APPROVAL_SUCCESS`;
export const SUBMIT_MANUAL_BOOKING_APPROVAL_ERROR = `SUBMIT_MANUAL_BOOKING_APPROVAL_ERROR`;
export const SUBMIT_MANUAL_BOOKING_APPROVAL_EMPTY = `SUBMIT_MANUAL_BOOKING_APPROVAL_EMPTY`;

export const DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL = `DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL`;
export const DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_SUCCESS = `DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_SUCCESS`;
export const DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_ERROR = `DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_ERROR`;
export const DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_EMPTY = `DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_EMPTY`;

export const VALIDATE_JIRA_TICKET = `VALIDATE_JIRA_TICKET`;
export const VALIDATE_JIRA_TICKET_SUCCESS = `VALIDATE_JIRA_TICKET_SUCCESS`;
export const VALIDATE_JIRA_TICKET_ERROR = `VALIDATE_JIRA_TICKET_ERROR`;
export const VALIDATE_JIRA_TICKET_EMPTY = `VALIDATE_JIRA_TICKET_EMPTY`;

export const GET_UTILITY_USER_DETAILS = `GET_UTILITY_USER_DETAILS`;
export const GET_UTILITY_USER_DETAILS_SUCCESS = `GET_UTILITY_USER_DETAILS_SUCCESS`;
export const GET_UTILITY_USER_DETAILS_ERROR = `GET_UTILITY_USER_DETAILS_ERROR`;
export const GET_UTILITY_USER_DETAILS_EMPTY = `GET_UTILITY_USER_DETAILS_EMPTY`;

export const GET_SUB_CATEGORY_RESOLUTIONS = `GET_SUB_CATEGORY_RESOLUTIONS`;
export const GET_SUB_CATEGORY_RESOLUTIONS_SUCCESS = `GET_SUB_CATEGORY_RESOLUTIONS_SUCCESS`;
export const GET_SUB_CATEGORY_RESOLUTIONS_ERROR = `GET_SUB_CATEGORY_RESOLUTIONS_ERROR`;
export const GET_SUB_CATEGORY_RESOLUTIONS_EMPTY = `GET_SUB_CATEGORY_RESOLUTIONS_EMPTY`;

export const GET_GLOBAL_VENDORS = `GET_GLOBAL_VENDORS`;
export const GET_GLOBAL_VENDORS_SUCCESS = `GET_GLOBAL_VENDORS_SUCCESS`;
export const GET_GLOBAL_VENDORS_ERROR = `GET_GLOBAL_VENDORS_ERROR`;
export const GET_GLOBAL_VENDORS_EMPTY = `GET_GLOBAL_VENDORS_EMPTY`;

export const CLIENT_VALIDATE_OTP_V2 = `CLIENT_VALIDATE_OTP_V2`;
export const CLIENT_VALIDATE_OTP_V2_SUCCESS = `CLIENT_VALIDATE_OTP_V2_SUCCESS`;
export const CLIENT_VALIDATE_OTP_V2_ERROR = `CLIENT_VALIDATE_OTP_V2_ERROR`;
export const CLIENT_VALIDATE_OTP_V2_EMPTY = `CLIENT_VALIDATE_OTP_V2_EMPTY`;

export const CLIENT_RESEND_OTP_V2 = `CLIENT_RESEND_OTP_V2`;
export const CLIENT_RESEND_OTP_V2_SUCCESS = `CLIENT_RESEND_OTP_V2_SUCCESS`;
export const CLIENT_RESEND_OTP_V2_ERROR = `CLIENT_RESEND_OTP_V2_ERROR`;
export const CLIENT_RESEND_OTP_V2_EMPTY = `CLIENT_RESEND_OTP_V2_EMPTY`;

// GET VENDOR DETAILS
export const GET_VENDOR_DETAILS = `GET_VENDOR_DETAILS`;
export const GET_VENDOR_DETAILS_SUCCESS = `GET_VENDOR_DETAILS_SUCCESS`;
export const GET_VENDOR_DETAILS_ERROR = `GET_VENDOR_DETAILS_ERROR`;
export const GET_VENDOR_DETAILS_EMPTY = `GET_VENDOR_DETAILS_EMPTY`;

/* ----------------- FAB-SURGE ----------------- */

/* ----------------- COMPAIGN ----------------- */

// LIST COMPAIGN
export const LIST_COMPAIGN = `LIST_COMPAIGN`;
export const LIST_COMPAIGN_SUCCESS = `LIST_COMPAIGN_SUCCESS`;
export const LIST_COMPAIGN_ERROR = `LIST_COMPAIGN_ERROR`;
export const LIST_COMPAIGN_EMPTY = `LIST_COMPAIGN_EMPTY`;

// CREATE SURGE COMPAIGN
export const CREATE_SURGE_COMPAIGN = `CREATE_SURGE_COMPAIGN`;
export const CREATE_SURGE_COMPAIGN_SUCCESS = `CREATE_SURGE_COMPAIGN_SUCCESS`;
export const CREATE_SURGE_COMPAIGN_ERROR = `CREATE_SURGE_COMPAIGN_ERROR`;
export const CREATE_SURGE_COMPAIGN_EMPTY = `CREATE_SURGE_COMPAIGN_EMPTY`;

// UPDATE SURGE COMPAIGN
export const UPDATE_SURGE_COMPAIGN = `UPDATE_SURGE_COMPAIGN`;
export const UPDATE_SURGE_COMPAIGN_SUCCESS = `UPDATE_SURGE_COMPAIGN_SUCCESS`;
export const UPDATE_SURGE_COMPAIGN_ERROR = `UPDATE_SURGE_COMPAIGN_ERROR`;
export const UPDATE_SURGE_COMPAIGN_EMPTY = `UPDATE_SURGE_COMPAIGN_EMPTY`;

// EXECUTE (TRIGGER NOW) SURGE COMPAIGN
export const EXECUTE_SURGE_COMPAIGN = `EXECUTE_SURGE_COMPAIGN`;
export const EXECUTE_SURGE_COMPAIGN_SUCCESS = `EXECUTE_SURGE_COMPAIGN_SUCCESS`;
export const EXECUTE_SURGE_COMPAIGN_ERROR = `EXECUTE_SURGE_COMPAIGN_ERROR`;
export const EXECUTE_SURGE_COMPAIGN_EMPTY = `EXECUTE_SURGE_COMPAIGN_EMPTY`;

// GET COMPAIGN SUMMARY
export const GET_COMPAIGN_SUMMARY = `GET_COMPAIGN_SUMMARY`;
export const GET_COMPAIGN_SUMMARY_SUCCESS = `GET_COMPAIGN_SUMMARY_SUCCESS`;
export const GET_COMPAIGN_SUMMARY_ERROR = `GET_COMPAIGN_SUMMARY_ERROR`;
export const GET_COMPAIGN_SUMMARY_EMPTY = `GET_COMPAIGN_SUMMARY_EMPTY`;

// GET COMPAIGN DETAILS
export const GET_COMPAIGN_DETAILS = `GET_COMPAIGN_DETAILS`;
export const GET_COMPAIGN_DETAILS_SUCCESS = `GET_COMPAIGN_DETAILS_SUCCESS`;
export const GET_COMPAIGN_DETAILS_ERROR = `GET_COMPAIGN_DETAILS_ERROR`;
export const GET_COMPAIGN_DETAILS_EMPTY = `GET_COMPAIGN_DETAILS_EMPTY`;

// GET CAMPAIGN RULES (for a campaign — used to prefill the wizard on draft update)
export const GET_CAMPAIGN_RULES = `GET_CAMPAIGN_RULES`;
export const GET_CAMPAIGN_RULES_SUCCESS = `GET_CAMPAIGN_RULES_SUCCESS`;
export const GET_CAMPAIGN_RULES_ERROR = `GET_CAMPAIGN_RULES_ERROR`;
export const GET_CAMPAIGN_RULES_EMPTY = `GET_CAMPAIGN_RULES_EMPTY`;

// GET CAMPAIGN EFFECTS (for a campaign — used to prefill the wizard on draft update)
export const GET_CAMPAIGN_EFFECTS = `GET_CAMPAIGN_EFFECTS`;
export const GET_CAMPAIGN_EFFECTS_SUCCESS = `GET_CAMPAIGN_EFFECTS_SUCCESS`;
export const GET_CAMPAIGN_EFFECTS_ERROR = `GET_CAMPAIGN_EFFECTS_ERROR`;
export const GET_CAMPAIGN_EFFECTS_EMPTY = `GET_CAMPAIGN_EFFECTS_EMPTY`;

// GET COMPAIGN META CONFIG
export const GET_COMPAIGN_META_CONFIG = `GET_COMPAIGN_META_CONFIG`;
export const GET_COMPAIGN_META_CONFIG_SUCCESS = `GET_COMPAIGN_META_CONFIG_SUCCESS`;
export const GET_COMPAIGN_META_CONFIG_ERROR = `GET_COMPAIGN_META_CONFIG_ERROR`;
export const GET_COMPAIGN_META_CONFIG_EMPTY = `GET_COMPAIGN_META_CONFIG_EMPTY`;

// GET RULE META CONFIG
export const GET_RULE_META_CONFIG = `GET_RULE_META_CONFIG`;
export const GET_RULE_META_CONFIG_SUCCESS = `GET_RULE_META_CONFIG_SUCCESS`;
export const GET_RULE_META_CONFIG_ERROR = `GET_RULE_META_CONFIG_ERROR`;
export const GET_RULE_META_CONFIG_EMPTY = `GET_RULE_META_CONFIG_EMPTY`;

// LIST RULES
export const LIST_RULES = `LIST_RULES`;
export const LIST_RULES_SUCCESS = `LIST_RULES_SUCCESS`;
export const LIST_RULES_ERROR = `LIST_RULES_ERROR`;
export const LIST_RULES_EMPTY = `LIST_RULES_EMPTY`;

// GET RULES DETAILS
export const GET_RULES_DETAILS = `GET_RULES_DETAILS`;
export const GET_RULES_DETAILS_SUCCESS = `GET_RULES_DETAILS_SUCCESS`;
export const GET_RULES_DETAILS_ERROR = `GET_RULES_DETAILS_ERROR`;
export const GET_RULES_DETAILS_EMPTY = `GET_RULES_DETAILS_EMPTY`;

// Create Campaign Effect
export const CREATE_CAMPAIGN_EFFECT = `CREATE_CAMPAIGN_EFFECT`;
export const CREATE_CAMPAIGN_EFFECT_SUCCESS = `CREATE_CAMPAIGN_EFFECT_SUCCESS`;
export const CREATE_CAMPAIGN_EFFECT_ERROR = `CREATE_CAMPAIGN_EFFECT_ERROR`;
export const CREATE_CAMPAIGN_EFFECT_EMPTY = `CREATE_CAMPAIGN_EFFECT_EMPTY`;

// Create Campaign Rule
export const CREATE_CAMPAIGN_RULE = `CREATE_CAMPAIGN_RULE`;
export const CREATE_CAMPAIGN_RULE_SUCCESS = `CREATE_CAMPAIGN_RULE_SUCCESS`;
export const CREATE_CAMPAIGN_RULE_ERROR = `CREATE_CAMPAIGN_RULE_ERROR`;
export const CREATE_CAMPAIGN_RULE_EMPTY = `CREATE_CAMPAIGN_RULE_EMPTY`;

// APPROVE COMPAIGN
export const APPROVAL_SURGE_COMPAIGN = `APPROVAL_SURGE_COMPAIGN`;
export const APPROVAL_SURGE_COMPAIGN_SUCCESS = `APPROVAL_SURGE_COMPAIGN_SUCCESS`;
export const APPROVAL_SURGE_COMPAIGN_ERROR = `APPROVAL_SURGE_COMPAIGN_ERROR`;
export const APPROVAL_SURGE_COMPAIGN_EMPTY = `APPROVAL_SURGE_COMPAIGN_EMPTY`;

/* ----------------- TEMPLATE MANAGEMENT ----------------- */

// GET SURGE TEMPLATE
export const GET_SURGE_TEMPLATE = `GET_SURGE_TEMPLATE`;
export const GET_SURGE_TEMPLATE_SUCCESS = `GET_SURGE_TEMPLATE_SUCCESS`;
export const GET_SURGE_TEMPLATE_ERROR = `GET_SURGE_TEMPLATE_ERROR`;
export const GET_SURGE_TEMPLATE_EMPTY = `GET_SURGE_TEMPLATE_EMPTY`;

// GET SURGE TEMPLATE DETAILS
export const GET_SURGE_TEMPLATE_DETAILS = `GET_SURGE_TEMPLATE_DETAILS`;
export const GET_SURGE_TEMPLATE_DETAILS_SUCCESS = `GET_SURGE_TEMPLATE_DETAILS_SUCCESS`;
export const GET_SURGE_TEMPLATE_DETAILS_ERROR = `GET_SURGE_TEMPLATE_DETAILS_ERROR`;
export const GET_SURGE_TEMPLATE_DETAILS_EMPTY = `GET_SURGE_TEMPLATE_DETAILS_EMPTY`;

// CREATE SURGE TEMPLATE
export const CREATE_SURGE_TEMPLATE = `CREATE_SURGE_TEMPLATE`;
export const CREATE_SURGE_TEMPLATE_SUCCESS = `CREATE_SURGE_TEMPLATE_SUCCESS`;
export const CREATE_SURGE_TEMPLATE_ERROR = `CREATE_SURGE_TEMPLATE_ERROR`;
export const CREATE_SURGE_TEMPLATE_EMPTY = `CREATE_SURGE_TEMPLATE_EMPTY`;

// GET SURGE TEMPLATE VERSION
export const GET_SURGE_TEMPLATE_VERSION = `GET_SURGE_TEMPLATE_VERSION`;
export const GET_SURGE_TEMPLATE_VERSION_SUCCESS = `GET_SURGE_TEMPLATE_VERSION_SUCCESS`;
export const GET_SURGE_TEMPLATE_VERSION_ERROR = `GET_SURGE_TEMPLATE_VERSION_ERROR`;
export const GET_SURGE_TEMPLATE_VERSION_EMPTY = `GET_SURGE_TEMPLATE_VERSION_EMPTY`;

// GET TEMPLATE BY ID (the campaign wizard's template summary — a fuller payload than
// the listing's details endpoint, so it gets its own slice rather than sharing one)
export const GET_TEMPLATE_BY_ID = `GET_TEMPLATE_BY_ID`;
export const GET_TEMPLATE_BY_ID_SUCCESS = `GET_TEMPLATE_BY_ID_SUCCESS`;
export const GET_TEMPLATE_BY_ID_ERROR = `GET_TEMPLATE_BY_ID_ERROR`;
export const GET_TEMPLATE_BY_ID_EMPTY = `GET_TEMPLATE_BY_ID_EMPTY`;

// GET TEMPLATE SCHEMA DIFF (this template vs the published, active one for the same
// entity type — a diff, not a template, so it gets its own slice rather than sharing
// GetTemplateById, which is usually on screen at the same time)
export const GET_TEMPLATE_SCHEMA_DIFF = `GET_TEMPLATE_SCHEMA_DIFF`;
export const GET_TEMPLATE_SCHEMA_DIFF_SUCCESS = `GET_TEMPLATE_SCHEMA_DIFF_SUCCESS`;
export const GET_TEMPLATE_SCHEMA_DIFF_ERROR = `GET_TEMPLATE_SCHEMA_DIFF_ERROR`;
export const GET_TEMPLATE_SCHEMA_DIFF_EMPTY = `GET_TEMPLATE_SCHEMA_DIFF_EMPTY`;

// APPROVE TEMPLATE
export const APPROVAL_SURGE_TEMPLATE = `APPROVAL_SURGE_TEMPLATE`;
export const APPROVAL_SURGE_TEMPLATE_SUCCESS = `APPROVAL_SURGE_TEMPLATE_SUCCESS`;
export const APPROVAL_SURGE_TEMPLATE_ERROR = `APPROVAL_SURGE_TEMPLATE_ERROR`;
export const APPROVAL_SURGE_TEMPLATE_EMPTY = `APPROVAL_SURGE_TEMPLATE_EMPTY`;

// APPROVE FILE UPLOAD
export const APPROVAL_SURGE_FILE_UPLOAD = `APPROVAL_SURGE_FILE_UPLOAD`;
export const APPROVAL_SURGE_FILE_UPLOAD_SUCCESS = `APPROVAL_SURGE_FILE_UPLOAD_SUCCESS`;
export const APPROVAL_SURGE_FILE_UPLOAD_ERROR = `APPROVAL_SURGE_FILE_UPLOAD_ERROR`;
export const APPROVAL_SURGE_FILE_UPLOAD_EMPTY = `APPROVAL_SURGE_FILE_UPLOAD_EMPTY`;

/* ----------------- USER MANAGEMENT ----------------- */

// FAB SURGE GET USER LIST
export const FAB_SURGE_GET_USER_LIST = `FAB_SURGE_GET_USER_LIST`;
export const FAB_SURGE_GET_USER_LIST_SUCCESS = `FAB_SURGE_GET_USER_LIST_SUCCESS`;
export const FAB_SURGE_GET_USER_LIST_ERROR = `FAB_SURGE_GET_USER_LIST_ERROR`;
export const FAB_SURGE_GET_USER_LIST_EMPTY = `FAB_SURGE_GET_USER_LIST_EMPTY`;

// FAB SURGE CREATE USER
export const FAB_SURGE_CREATE_USER = `FAB_SURGE_CREATE_USER`;
export const FAB_SURGE_CREATE_USER_SUCCESS = `FAB_SURGE_CREATE_USER_SUCCESS`;
export const FAB_SURGE_CREATE_USER_ERROR = `FAB_SURGE_CREATE_USER_ERROR`;
export const FAB_SURGE_CREATE_USER_EMPTY = `FAB_SURGE_CREATE_USER_EMPTY`;

// FAB SURGE GET USER ROLE
export const FAB_SURGE_GET_USER_ROLE = `FAB_SURGE_GET_USER_ROLE`;
export const FAB_SURGE_GET_USER_ROLE_SUCCESS = `FAB_SURGE_GET_USER_ROLE_SUCCESS`;
export const FAB_SURGE_GET_USER_ROLE_ERROR = `FAB_SURGE_GET_USER_ROLE_ERROR`;
export const FAB_SURGE_GET_USER_ROLE_EMPTY = `FAB_SURGE_GET_USER_ROLE_EMPTY`;

// FAB SURGE UPDATE USER ROLE
export const FAB_SURGE_UPDATE_USER_ROLE = `FAB_SURGE_UPDATE_USER_ROLE`;
export const FAB_SURGE_UPDATE_USER_ROLE_SUCCESS = `FAB_SURGE_UPDATE_USER_ROLE_SUCCESS`;
export const FAB_SURGE_UPDATE_USER_ROLE_ERROR = `FAB_SURGE_UPDATE_USER_ROLE_ERROR`;
export const FAB_SURGE_UPDATE_USER_ROLE_EMPTY = `FAB_SURGE_UPDATE_USER_ROLE_EMPTY`;

// FAB SURGE GET USER DETAILS
export const FAB_SURGE_GET_USER_DETAILS = `FAB_SURGE_GET_USER_DETAILS`;
export const FAB_SURGE_GET_USER_DETAILS_SUCCESS = `FAB_SURGE_GET_USER_DETAILS_SUCCESS`;
export const FAB_SURGE_GET_USER_DETAILS_ERROR = `FAB_SURGE_GET_USER_DETAILS_ERROR`;
export const FAB_SURGE_GET_USER_DETAILS_EMPTY = `FAB_SURGE_GET_USER_DETAILS_EMPTY`;

// FAB SURGE UPDATE USER STATUS
export const FAB_SURGE_UPDATE_USER_STATUS = `FAB_SURGE_UPDATE_USER_STATUS`;
export const FAB_SURGE_UPDATE_USER_STATUS_SUCCESS = `FAB_SURGE_UPDATE_USER_STATUS_SUCCESS`;
export const FAB_SURGE_UPDATE_USER_STATUS_ERROR = `FAB_SURGE_UPDATE_USER_STATUS_ERROR`;
export const FAB_SURGE_UPDATE_USER_STATUS_EMPTY = `FAB_SURGE_UPDATE_USER_STATUS_EMPTY`;

// FAB SURGE UPDATE EXISTING USER
export const FAB_SURGE_UPDATE_EXISTING_USER = `FAB_SURGE_UPDATE_EXISTING_USER`;
export const FAB_SURGE_UPDATE_EXISTING_USER_SUCCESS = `FAB_SURGE_UPDATE_EXISTING_USER_SUCCESS`;
export const FAB_SURGE_UPDATE_EXISTING_USER_ERROR = `FAB_SURGE_UPDATE_EXISTING_USER_ERROR`;
export const FAB_SURGE_UPDATE_EXISTING_USER_EMPTY = `FAB_SURGE_UPDATE_EXISTING_USER_EMPTY`;

// FAB SURGE GET USER SUMMARY
export const FAB_SURGE_GET_USER_SUMMARY = `FAB_SURGE_GET_USER_SUMMARY`;
export const FAB_SURGE_GET_USER_SUMMARY_SUCCESS = `FAB_SURGE_GET_USER_SUMMARY_SUCCESS`;
export const FAB_SURGE_GET_USER_SUMMARY_ERROR = `FAB_SURGE_GET_USER_SUMMARY_ERROR`;
export const FAB_SURGE_GET_USER_SUMMARY_EMPTY = `FAB_SURGE_GET_USER_SUMMARY_EMPTY`;

/* ----------------- LEDGER MANAGEMENT ----------------- */

// GET LEDGER LIST
export const GET_LEDGER_LIST = `GET_LEDGER_LIST`;
export const GET_LEDGER_LIST_SUCCESS = `GET_LEDGER_LIST_SUCCESS`;
export const GET_LEDGER_LIST_ERROR = `GET_LEDGER_LIST_ERROR`;
export const GET_LEDGER_LIST_EMPTY = `GET_LEDGER_LIST_EMPTY`;

// GET LEDGER SUMMARY
export const GET_LEDGER_SUMMARY = `GET_LEDGER_SUMMARY`;
export const GET_LEDGER_SUMMARY_SUCCESS = `GET_LEDGER_SUMMARY_SUCCESS`;
export const GET_LEDGER_SUMMARY_ERROR = `GET_LEDGER_SUMMARY_ERROR`;
export const GET_LEDGER_SUMMARY_EMPTY = `GET_LEDGER_SUMMARY_EMPTY`;

// GET LEDGER DETAILS
export const GET_LEDGER_DETAILS = `GET_LEDGER_DETAILS`;
export const GET_LEDGER_DETAILS_SUCCESS = `GET_LEDGER_DETAILS_SUCCESS`;
export const GET_LEDGER_DETAILS_ERROR = `GET_LEDGER_DETAILS_ERROR`;
export const GET_LEDGER_DETAILS_EMPTY = `GET_LEDGER_DETAILS_EMPTY`;

// GET LEDGER FILTER
export const GET_FAB_SURGE_FILTER = `GET_FAB_SURGE_FILTER`;
export const GET_FAB_SURGE_FILTER_SUCCESS = `GET_FAB_SURGE_FILTER_SUCCESS`;
export const GET_FAB_SURGE_FILTER_ERROR = `GET_FAB_SURGE_FILTER_ERROR`;
export const GET_FAB_SURGE_FILTER_EMPTY = `GET_FAB_SURGE_FILTER_EMPTY`;

// GET SURGE FILE LIST
export const GET_SURGE_FILE_LIST = `GET_SURGE_FILE_LIST`;
export const GET_SURGE_FILE_LIST_SUCCESS = `GET_SURGE_FILE_LIST_SUCCESS`;
export const GET_SURGE_FILE_LIST_ERROR = `GET_SURGE_FILE_LIST_ERROR`;
export const GET_SURGE_FILE_LIST_EMPTY = `GET_SURGE_FILE_LIST_EMPTY`;

// GET SURGE FILE DETAILS
export const GET_SURGE_FILE_DETAILS = `GET_SURGE_FILE_DETAILS`;
export const GET_SURGE_FILE_DETAILS_SUCCESS = `GET_SURGE_FILE_DETAILS_SUCCESS`;
export const GET_SURGE_FILE_DETAILS_ERROR = `GET_SURGE_FILE_DETAILS_ERROR`;
export const GET_SURGE_FILE_DETAILS_EMPTY = `GET_SURGE_FILE_DETAILS_EMPTY`;

// UPLOAD FILE
export const UPLOAD_SURGE_FILE = `UPLOAD_SURGE_FILE`;
export const UPLOAD_SURGE_FILE_SUCCESS = `UPLOAD_SURGE_FILE_SUCCESS`;
export const UPLOAD_SURGE_FILE_ERROR = `UPLOAD_SURGE_FILE_ERROR`;
export const UPLOAD_SURGE_FILE_EMPTY = `UPLOAD_SURGE_FILE_EMPTY`;

// GET UPLOAD SURGE TYPE
export const GET_UPLOAD_SURGE_TYPE = `GET_UPLOAD_SURGE_TYPE`;
export const GET_UPLOAD_SURGE_TYPE_SUCCESS = `GET_UPLOAD_SURGE_TYPE_SUCCESS`;
export const GET_UPLOAD_SURGE_TYPE_ERROR = `GET_UPLOAD_SURGE_TYPE_ERROR`;
export const GET_UPLOAD_SURGE_TYPE_EMPTY = `GET_UPLOAD_SURGE_TYPE_EMPTY`;

// GET UPLOAD SURGE TYPE
export const GET_FIELD_REGISTRY = `GET_FIELD_REGISTRY`;
export const GET_FIELD_REGISTRY_SUCCESS = `GET_FIELD_REGISTRY_SUCCESS`;
export const GET_FIELD_REGISTRY_ERROR = `GET_FIELD_REGISTRY_ERROR`;
export const GET_FIELD_REGISTRY_EMPTY = `GET_FIELD_REGISTRY_EMPTY`;

// CREATE FIELD REGISTRY
export const CREATE_FIELD_REGISTRY = `CREATE_FIELD_REGISTRY`;
export const CREATE_FIELD_REGISTRY_SUCCESS = `CREATE_FIELD_REGISTRY_SUCCESS`;
export const CREATE_FIELD_REGISTRY_ERROR = `CREATE_FIELD_REGISTRY_ERROR`;
export const CREATE_FIELD_REGISTRY_EMPTY = `CREATE_FIELD_REGISTRY_EMPTY`;

// UPDATE FIELD REGISTRY
export const UPDATE_FIELD_REGISTRY = `UPDATE_FIELD_REGISTRY`;
export const UPDATE_FIELD_REGISTRY_SUCCESS = `UPDATE_FIELD_REGISTRY_SUCCESS`;
export const UPDATE_FIELD_REGISTRY_ERROR = `UPDATE_FIELD_REGISTRY_ERROR`;
export const UPDATE_FIELD_REGISTRY_EMPTY = `UPDATE_FIELD_REGISTRY_EMPTY`;

// DELETE FIELD REGISTRY (soft delete)
export const DELETE_FIELD_REGISTRY = `DELETE_FIELD_REGISTRY`;
export const DELETE_FIELD_REGISTRY_SUCCESS = `DELETE_FIELD_REGISTRY_SUCCESS`;
export const DELETE_FIELD_REGISTRY_ERROR = `DELETE_FIELD_REGISTRY_ERROR`;
export const DELETE_FIELD_REGISTRY_EMPTY = `DELETE_FIELD_REGISTRY_EMPTY`;

// GET UPLOAD SURGE TYPE
export const DOWNLOAD_SURGE_SAMPLE_FILE = `DOWNLOAD_SURGE_SAMPLE_FILE`;
export const DOWNLOAD_SURGE_SAMPLE_FILE_SUCCESS = `DOWNLOAD_SURGE_SAMPLE_FILE_SUCCESS`;
export const DOWNLOAD_SURGE_SAMPLE_FILE_ERROR = `DOWNLOAD_SURGE_SAMPLE_FILE_ERROR`;
export const DOWNLOAD_SURGE_SAMPLE_FILE_EMPTY = `DOWNLOAD_SURGE_SAMPLE_FILE_EMPTY`;

// DOWNLOAD UPLOAD LOGS (all rows of one uploaded file; the same endpoint also
// serves INVALID via the logType argument)
export const DOWNLOAD_SURGE_LOGS = `DOWNLOAD_SURGE_LOGS`;
export const DOWNLOAD_SURGE_LOGS_SUCCESS = `DOWNLOAD_SURGE_LOGS_SUCCESS`;
export const DOWNLOAD_SURGE_LOGS_ERROR = `DOWNLOAD_SURGE_LOGS_ERROR`;
export const DOWNLOAD_SURGE_LOGS_EMPTY = `DOWNLOAD_SURGE_LOGS_EMPTY`;

// DOWNLOAD INVALID FILES
export const DOWNLOAD_INVALID_FILES = `DOWNLOAD_INVALID_FILES`;
export const DOWNLOAD_INVALID_FILES_SUCCESS = `DOWNLOAD_INVALID_FILES_SUCCESS`;
export const DOWNLOAD_INVALID_FILES_ERROR = `DOWNLOAD_INVALID_FILES_ERROR`;
export const DOWNLOAD_INVALID_FILES_EMPTY = `DOWNLOAD_INVALID_FILES_EMPTY`;

/* ----------------- CUSTOMER MANAGEMENT ----------------- */

// GET CARD FAB SURGE
export const GET_CARD_FAB_SURGE = `GET_CARD_FAB_SURGE`;
export const GET_CARD_FAB_SURGE_SUCCESS = `GET_CARD_FAB_SURGE_SUCCESS`;
export const GET_CARD_FAB_SURGE_ERROR = `GET_CARD_FAB_SURGE_ERROR`;
export const GET_CARD_FAB_SURGE_EMPTY = `GET_CARD_FAB_SURGE_EMPTY`;

// GET CASHBACK STATEMENT
export const GET_CASHBACK_STATEMENT = `GET_CASHBACK_STATEMENT`;
export const GET_CASHBACK_STATEMENT_SUCCESS = `GET_CASHBACK_STATEMENT_SUCCESS`;
export const GET_CASHBACK_STATEMENT_ERROR = `GET_CASHBACK_STATEMENT_ERROR`;
export const GET_CASHBACK_STATEMENT_EMPTY = `GET_CASHBACK_STATEMENT_EMPTY`;

// GET CASHBACK STATEMENT
export const GET_COMMULATIVE_EARNING = `GET_COMMULATIVE_EARNING`;
export const GET_COMMULATIVE_EARNING_SUCCESS = `GET_COMMULATIVE_EARNING_SUCCESS`;
export const GET_COMMULATIVE_EARNING_ERROR = `GET_COMMULATIVE_EARNING_ERROR`;
export const GET_COMMULATIVE_EARNING_EMPTY = `GET_COMMULATIVE_EARNING_EMPTY`;

// GET REASON FOR SURGE
export const GET_REASON_SURGE = `GET_REASON_SURGE`;
export const GET_REASON_SURGE_SUCCESS = `GET_REASON_SURGE_SUCCESS`;
export const GET_REASON_SURGE_ERROR = `GET_REASON_SURGE_ERROR`;
export const GET_REASON_SURGE_EMPTY = `GET_REASON_SURGE_EMPTY`;

/* ----------------- DIGITAL BOOKING MANAGEMENT ----------------- */

// GET DIGITAL OFFERS (offer filter dropdown)
export const GET_DIGITAL_OFFERS = `GET_DIGITAL_OFFERS`;
export const GET_DIGITAL_OFFERS_SUCCESS = `GET_DIGITAL_OFFERS_SUCCESS`;
export const GET_DIGITAL_OFFERS_ERROR = `GET_DIGITAL_OFFERS_ERROR`;
export const GET_DIGITAL_OFFERS_EMPTY = `GET_DIGITAL_OFFERS_EMPTY`;

// GET DIGITAL AUTH METHODS (auth method filter dropdown)
export const GET_DIGITAL_AUTH_METHODS = `GET_DIGITAL_AUTH_METHODS`;
export const GET_DIGITAL_AUTH_METHODS_SUCCESS = `GET_DIGITAL_AUTH_METHODS_SUCCESS`;
export const GET_DIGITAL_AUTH_METHODS_ERROR = `GET_DIGITAL_AUTH_METHODS_ERROR`;
export const GET_DIGITAL_AUTH_METHODS_EMPTY = `GET_DIGITAL_AUTH_METHODS_EMPTY`;

// GET DIGITAL CARD STATES (workflow state pills above the listing)
export const GET_DIGITAL_CARD_STATES = `GET_DIGITAL_CARD_STATES`;
export const GET_DIGITAL_CARD_STATES_SUCCESS = `GET_DIGITAL_CARD_STATES_SUCCESS`;
export const GET_DIGITAL_CARD_STATES_ERROR = `GET_DIGITAL_CARD_STATES_ERROR`;
export const GET_DIGITAL_CARD_STATES_EMPTY = `GET_DIGITAL_CARD_STATES_EMPTY`;

/* ----------------- OUTLET MANAGEMENT ----------------- */

// CREATE OUTLET
export const CREATE_OUTLET = `CREATE_OUTLET`;
export const CREATE_OUTLET_SUCCESS = `CREATE_OUTLET_SUCCESS`;
export const CREATE_OUTLET_ERROR = `CREATE_OUTLET_ERROR`;
export const CREATE_OUTLET_EMPTY = `CREATE_OUTLET_EMPTY`;

// GET OUTLETS
export const GET_OUTLETS = `GET_OUTLETS`;
export const GET_OUTLETS_SUCCESS = `GET_OUTLETS_SUCCESS`;
export const GET_OUTLETS_ERROR = `GET_OUTLETS_ERROR`;
export const GET_OUTLETS_EMPTY = `GET_OUTLETS_EMPTY`;

// UPDATE OUTLET
export const UPDATE_OUTLET = `UPDATE_OUTLET`;
export const UPDATE_OUTLET_SUCCESS = `UPDATE_OUTLET_SUCCESS`;
export const UPDATE_OUTLET_ERROR = `UPDATE_OUTLET_ERROR`;
export const UPDATE_OUTLET_EMPTY = `UPDATE_OUTLET_EMPTY`;

// GET OUTLET DETAILS
export const GET_OUTLET_DETAILS = `GET_OUTLET_DETAILS`;
export const GET_OUTLET_DETAILS_SUCCESS = `GET_OUTLET_DETAILS_SUCCESS`;
export const GET_OUTLET_DETAILS_ERROR = `GET_OUTLET_DETAILS_ERROR`;
export const GET_OUTLET_DETAILS_EMPTY = `GET_OUTLET_DETAILS_EMPTY`;

// GET OUTLET STATUS COUNTS (active + inactive totals for the listing tabs)
export const GET_OUTLET_STATUS_COUNTS = `GET_OUTLET_STATUS_COUNTS`;
export const GET_OUTLET_STATUS_COUNTS_SUCCESS = `GET_OUTLET_STATUS_COUNTS_SUCCESS`;
export const GET_OUTLET_STATUS_COUNTS_ERROR = `GET_OUTLET_STATUS_COUNTS_ERROR`;
export const GET_OUTLET_STATUS_COUNTS_EMPTY = `GET_OUTLET_STATUS_COUNTS_EMPTY`;

/* ----------------- VALIDATION MANAGEMENT ----------------- */

// GET OUTLET FILTERS (outlet dropdown on the validation module)
export const GET_OUTLET_FILTERS = `GET_OUTLET_FILTERS`;
export const GET_OUTLET_FILTERS_SUCCESS = `GET_OUTLET_FILTERS_SUCCESS`;
export const GET_OUTLET_FILTERS_ERROR = `GET_OUTLET_FILTERS_ERROR`;
export const GET_OUTLET_FILTERS_EMPTY = `GET_OUTLET_FILTERS_EMPTY`;

// VERIFY COUPON (digital redemption)
export const VERIFY_COUPON = `VERIFY_COUPON`;
export const VERIFY_COUPON_SUCCESS = `VERIFY_COUPON_SUCCESS`;
export const VERIFY_COUPON_ERROR = `VERIFY_COUPON_ERROR`;
export const VERIFY_COUPON_EMPTY = `VERIFY_COUPON_EMPTY`;

// UPDATE VENDOR STATUS
export const UPDATE_VENDOR_STATUS_V2 = `UPDATE_VENDOR_STATUS_V2`;
export const UPDATE_VENDOR_STATUS_V2_SUCCESS = `UPDATE_VENDOR_STATUS_V2_SUCCESS`;
export const UPDATE_VENDOR_STATUS_V2_ERROR = `UPDATE_VENDOR_STATUS_V2_ERROR`;
export const UPDATE_VENDOR_STATUS_V2_EMPTY = `UPDATE_VENDOR_STATUS_V2_EMPTY`;
